import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SignupService } from '../../../services/signup.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { WatcherService } from 'src/app/services/watcher.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { ActivatedRoute, Router } from '@angular/router';
import { LatinCharacterService } from 'src/app/services/nonlatintolatin.service';
import { codeMaskList } from 'src/app/shared/codemasklist';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { AddItemForCustomsDialog } from './addItemForCustoms-dialog';
import { MatStepper } from '@angular/material/stepper';
import { IPayPalConfig, ICreateOrderRequest } from 'ngx-paypal';
import { catchError, switchMap } from 'rxjs/operators';
import { ChangeSenderInfoDialog } from './change-sender-info-dialog/change-sender-info-dialog';
import { EditItemForCustomsDialog } from './editCustomItemDialog/edit-custom-item-dialog';
import { CreateShipmentErrorDialog } from './create-shipment-error-dialog/create-shipment-error-dialog';
import { hostArrivedPackValidator } from 'src/app/directives/hostArrivedPackValidator.directive';
import { SelectSenderInfoDialog } from './select-sender-info-dialog/select-sender-info-dialog';
import { B2BArrangePickupDialog } from 'src/app/features/B2B/b2b-arrange-pickup-dialog/b2b-arrange-pickup-dialog';
import { B2BArrangePickupDetailsDialog } from 'src/app/features/B2B/b2b-pickup-details-dialog/b2b-pickup-details-dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
declare var $;
declare var Stripe: any;

interface ParsedParams {
  company_id: string;
  service_type: string;
  vendor: string;
  insuranceSelected: string;
  invoiceExpected: string;
  promoCode: string;
  serviceType: string;
  isDynamic: string;
  rateId: string;
  service: string;
  shipmentId: string;
  b2b_shipment_number: string;
  b2b_recipient_id: string;
  b2b_shipment_id: string;
  shopper_email: string;
  b2b_user_email: string;
  from_address_id: string;
  to_address: string;
  from_address: string;
  parcel: string;
  customs_info: string;
  options: string;
  insurance: string;
  insurance_exists: string;
}

@Component({
  selector: 'app-b2b-create-shipment',
  templateUrl: './b2b-create-shipment.component.html',
  styleUrls: ['./b2b-create-shipment.component.css']
})
export class B2BCreateShipmentComponent implements OnInit, AfterViewInit {
  comingFromContactus: boolean = false;
  dashboardContainerHeight = '630px';
  isSelectsDisabled: boolean = true;
  paymentDone = false;
  currentStep = 0;
  isFirstStepCompleted = false;
  isSecondStepCompleted = false;
  isThirdStepCompleted = false;
  isFourthStepCompleted = false;
  new_messages;
  memberDetails;
  pageOfItems: Array<any>;
  userID;
  token;
  allCountries;
  selectedAddress;
  formattedAddress = "";
  codeMaskList = codeMaskList;
  testMask = "";

  options = {
    //componentRestrictions: { country: 'UA' }
    fields: ["address_components", "place_id"],
    types: ["address"],
  }
  @ViewChild("placesRef") placesRef!: ElementRef;
  autocomplete: google.maps.places.Autocomplete | undefined;
  @ViewChild('stepper') stepper: MatStepper;
  ngAfterViewInit() {
    if (typeof google !== 'undefined' && google.maps) {
      this.stepper._stepHeader.forEach((x) => {
        x._elementRef.nativeElement.style.pointerEvents = 'none';
      });

      this.autocomplete = new google.maps.places.Autocomplete(
        this.placesRef.nativeElement
      );

      this.autocomplete.addListener('place_changed', () => {
        const place = this.autocomplete?.getPlace();
        if (place) {
          this.handleAddressChange(place, 'add');
        }
      });
    } else {
      console.error('Google Maps API not loaded.');
    }
    // Ensure stepper is properly initialized
    if (this.stepper) {
      this.stepper.selectedIndex = this.currentStep;
    }
  }
  lang;
  form = new FormGroup({
    recipient: new FormControl('', Validators.required),
    companyName: new FormControl(''),
    emailAddress: new FormControl('', [Validators.required, Validators.email]),
    phoneNumber: new FormControl('', Validators.required),
    addressLineOne: new FormControl('', Validators.required),
    addressLineTwo: new FormControl(''),
    country: new FormControl('', Validators.required),
    cityName: new FormControl('', Validators.required),
    state: new FormControl(''),
    postCode: new FormControl('', Validators.required),
    defaultAddress: new FormControl(false),
  });
  customsForm = new FormGroup({
    contentType: new FormControl('Merchandise', Validators.required),
    explanationOfContent: new FormControl(''),
    restrictionType: new FormControl('None', Validators.required),
    explanationOfRestrictionType: new FormControl(''),
    nonDeliveryAction: new FormControl('Abandon', Validators.required),
    eelOrPfcNumber: new FormControl('NOEEI 30.37(a)', Validators.required),
    signature: new FormControl('', Validators.required),
    customsItems: new FormControl([], Validators.required),
  })
  parcelAndLabelOptionsForm = new FormGroup({
    length: new FormControl('', [Validators.required, hostArrivedPackValidator()]),
    width: new FormControl('', [Validators.required, hostArrivedPackValidator()]),
    height: new FormControl('', [Validators.required, hostArrivedPackValidator()]),
    weight: new FormControl('', [Validators.required, hostArrivedPackValidator()]),
    labelFormat: new FormControl('PDF', Validators.required),
    referenceID: new FormControl(''),
    invoiceNumber: new FormControl(''),
    predefinedPackage: new FormControl(''),
    weightUnit: new FormControl('Pound', Validators.required),
    dimensionUnit: new FormControl('Inch', Validators.required),
  })
  parcelDimensionUnit = 'Inch';
  parcelWeightUnit = 'Pound';
  dimensionUnitList = ['Inch', 'Centimeter'];
  weightUnitList = ['Pound', 'Kilogram'];
  measurementsUnitsObJ = [
    { id: 0, dimensionUnit: 'Inch', weightUnit: 'Pound' },
    { id: 1, dimensionUnit: 'Centimeter', weightUnit: 'Kilogram' }
  ]
  stripeM;
  paymentRequestM;
  customSenderInfo: b2bSenderInfo = {};
  createdShipmentID: any = '';
  htsList: any = [];
  showSignatiure = false;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    public signUpService: SignupService,
    private toastr: ToastrService,
    private watcherService: WatcherService,
    private store: Store<AppState>,
    private router: Router,
    private route: ActivatedRoute,
    private latinCharService: LatinCharacterService,
    public dialog: MatDialog,
    private clipboard: Clipboard,
    private gtmService: GoogleTagManagerService,
    private $gaService: GoogleAnalyticsService,
    private cdr: ChangeDetectorRef // Added ChangeDetectorRef
  ) {
    this.store.select('auth').subscribe(state => {
      this.token = state.token;
      this.userID = state.user?.id;
      if (this.userID === '66b5f93192539c6048a62356' || this.userID === '676b353892539c44f3fc22bd') {
        this.showSignatiure = false;
      } else {
        this.showSignatiure = false;
      }
    })
    if (this.userID && this.token) {
      this.signUpService.getUserByUserID(this.userID, this.token).subscribe(data => {
        this.memberDetails = data["data"];
        this.customsForm.controls.signature.setValue(`${this.memberDetails.name} ${this.memberDetails.surname}`);
        let shipmentBookingData = JSON.parse(localStorage.getItem('shipmentBookingData'));
        let customSenderInfo = shipmentBookingData?.step0?.customSenderInfo;
        if (this.memberDetails.addresses.length > 0) {
          this.selectB2BAddress(0);
          let senderPhoneNumber = `${this.memberDetails.phone.country_code} ${this.memberDetails.phone.phone_number}`;
          this.customSenderInfo = {
            senderName: `${this.memberDetails.name} ${this.memberDetails.surname}`,
            senderPhone: senderPhoneNumber,
            senderEmail: data['data'].email,
            addressLineOne: data['data']['addresses'][0]['line1'],
            addressLineTwo: data['data']['addresses'][0]['line2'],
            country: data['data']['addresses'][0]['country_code'],
            cityName: data['data']['addresses'][0]['city_name'],
            state: data['data']['addresses'][0]['state'],
            postCode: data['data']['addresses'][0]['post_code'],
            id: data['data']['addresses'][0]['id']
          }

          if (shipmentBookingData) {
            this.patchValuesFromLocalStorage();
          }
        } else {
          if (shipmentBookingData) {
            const addAddressPayload = {
              name: "",
              line1: customSenderInfo.addressLineOne,
              line2: customSenderInfo.addressLineTwo,
              city_name: customSenderInfo.cityName,
              state: customSenderInfo.state,
              post_code: customSenderInfo.postCode,
              country_code: customSenderInfo.country,
              phone: customSenderInfo.senderPhone,
              email: customSenderInfo.senderEmail,
              active: false,
              full_name: customSenderInfo.senderName
            }
            this.signUpService.AddShopperAddress(this.token, addAddressPayload).subscribe({
              next: data => {
                if (data['result']['status'] == 200) {
                  this.customSenderInfo.id = data['data'][data["data"].length - 1]['id'];
                  this.customSenderInfo = {
                    senderName: `${this.memberDetails.name} ${this.memberDetails.surname}`,
                    senderPhone: `${this.memberDetails.phone.country_code} ${this.memberDetails.phone.phone_number}`,
                    senderEmail: this.memberDetails.email,
                    addressLineOne: data['data'][data["data"].length - 1]['line1'],
                    addressLineTwo: data['data'][data["data"].length - 1]['line2'],
                    country: data['data'][data["data"].length - 1]['country_code'],
                    cityName: data['data'][data["data"].length - 1]['city_name'],
                    state: data['data'][data["data"].length - 1]['state'],
                    postCode: data['data'][data["data"].length - 1]['post_code'],
                    id: data['data'][data["data"].length - 1]['id']
                  }
                  this.selectedB2BAddress = data['data'][data["data"].length - 1];
                  this.patchValuesFromLocalStorage();
                }
              }
            })
          } else {
            this.patchValuesFromLocalStorage();
          }
        }
        if (data["data"].payment_methods?.length > 0) {
          if (data["data"].payment_methods.filter(p => p.type == 'paypal' && p.status == 'VERIFIED').length > 0) {
            localStorage.setItem('paypal_verified', 'true');
            this.initConfigForVerified();
            this.isPaypalPaymentValidation = JSON.parse(localStorage.getItem('paypal_verified'));
          } else {
            localStorage.setItem('paypal_verified', 'false');
            this.initConfigForUnverified();
            this.isPaypalPaymentValidation = JSON.parse(localStorage.getItem('paypal_verified'));
          }
        } else {
          localStorage.setItem('paypal_verified', 'false');
          this.initConfigForUnverified();
        }

      })
      this.signUpService.getHTS(this.token).subscribe({
        next: htsResponse => {
          if (htsResponse['result']['status'] === 200) {
            this.htsList = htsResponse['data'].filter(htsContent => {
              return htsContent.is_active
            })
          }
        },
        error: err => {
          this.toastr.error("Can not get HTS List!", "Error");
        }
      })
    } else {
      this.comingFromContactus = true;
    }
    this.signUpService.getHTS('').subscribe({
      next: htsResponse => {
        if (htsResponse['result']['status'] === 200) {
          this.htsList = htsResponse['data'].filter(htsContent => {
            return htsContent.is_active
          })
        }
      },
      error: err => {
        this.toastr.error("Can not get HTS List!", "Error");
      }
    })
    // Stripe
    this.stripeClientSecret = this.signUpService.stripeClientSecret;
    this.stripeHostName = this.signUpService.stripeHostName;
    this.stripeM = Stripe(this.stripeClientSecret);
    this.paymentRequestM = this.stripeM.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'B2B Create Shipment Initial Intent',
        amount: 1,
      },
      requestPayerName: true,
      requestPayerEmail: true
    });
  }
  name;
  animal;
  step1isValid: boolean = false;
  step2isValid: boolean = false;
  step3isValid: boolean = false;
  step4isValid: boolean = false;
  canMoveNext: boolean = false;
  stepTitles = ['Address', 'Customs', 'Parcel & Label Options', 'Carrier & Service', 'Print Label'];
  reloadComponent(): void {
    window.location.reload();
  }
  userB2bActive;


  sendGTMSuccessEvent(data) {
    const gtmTag = {
      event: 'gtmB2BShipmentSuccess',
      data: {
        amount: data?.charge?.paid?.amount || 0,
        email: data.b2b_user_address?.email || this.memberDetails?.email || '',
      },
    };
    this.gtmService.pushTag(gtmTag);

    this.$gaService.event(
      'b2b_shipment_success',
      'b2b_shipment_success',
      data.b2b_user_address?.email || this.memberDetails?.email || '',
      data?.charge?.paid?.amount || 0
    );
  }

  patchValuesFromLocalStorage() {
    let shipmentBookingData = JSON.parse(localStorage.getItem('shipmentBookingData'));
    if (shipmentBookingData?.step0?.form) {
      this.form.patchValue({
        recipient: shipmentBookingData?.step0?.form.recipient,
        companyName: shipmentBookingData?.step0?.form.companyName,
        emailAddress: shipmentBookingData?.step0?.form.emailAddress,
        phoneNumber: shipmentBookingData?.step0?.form.phoneNumber,
        addressLineOne: shipmentBookingData?.step0?.form.addressLineOne,
        addressLineTwo: shipmentBookingData?.step0?.form.addressLineTwo,
        country: shipmentBookingData?.step0?.form.country,
        cityName: shipmentBookingData?.step0?.form.cityName,
        state: shipmentBookingData?.step0?.form.state,
        postCode: shipmentBookingData?.step0?.form.postCode,
      });
    }
    if (shipmentBookingData?.step1?.customsForm) {
      this.customsForm.patchValue({
        contentType: shipmentBookingData?.step1?.customsForm.contentType,
        explanationOfContent: shipmentBookingData?.step1?.customsForm.explanationOfContent,
        restrictionType: shipmentBookingData?.step1?.customsForm.restrictionType,
        explanationOfRestrictionType: shipmentBookingData?.step1?.customsForm.explanationOfRestrictionType,
        nonDeliveryAction: shipmentBookingData?.step1?.customsForm.nonDeliveryAction,
        eelOrPfcNumber: shipmentBookingData?.step1?.customsForm.eelOrPfcNumber,
        signature: shipmentBookingData?.step1?.customsForm.signature ?? this.memberDetails.name + ' ' + this.memberDetails.surname,
        customsItems: shipmentBookingData?.step1?.customsForm.customsItems
      });
    }
    if (shipmentBookingData?.step2?.parcelAndLabelOptionsForm) {
      this.parcelAndLabelOptionsForm.patchValue({
        length: shipmentBookingData?.step2?.parcelAndLabelOptionsForm.length,
        width: shipmentBookingData?.step2?.parcelAndLabelOptionsForm.width,
        height: shipmentBookingData?.step2?.parcelAndLabelOptionsForm.height,
        weight: shipmentBookingData?.step2?.parcelAndLabelOptionsForm.weight,
        labelFormat: shipmentBookingData?.step2?.parcelAndLabelOptionsForm.labelFormat,
        referenceID: shipmentBookingData?.step2?.parcelAndLabelOptionsForm.referenceID,
        invoiceNumber: shipmentBookingData?.step2?.parcelAndLabelOptionsForm.invoiceNumber,
        predefinedPackage: shipmentBookingData?.step2?.parcelAndLabelOptionsForm.predefinedPackage,
        weightUnit: shipmentBookingData?.step2?.parcelAndLabelOptionsForm.weightUnit,
        dimensionUnit: shipmentBookingData?.step2?.parcelAndLabelOptionsForm.dimensionUnit,
      });
    }
    this.step1isValid = true;
    this.step2isValid = true;
    this.step3isValid = true;
    this.step4isValid = true;
    this.currentStep = 2;
    this.cdr.detectChanges();
    this.moveNextStep();
  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const paramPaymentIntentStatus = params.redirect_status;
      const paramPaymentIntent = params.payment_intent;
      if (paramPaymentIntent && paramPaymentIntentStatus == 'succeeded') {
        try {
          const url = new URL(location.href);
          const searchParams = new URLSearchParams(url.search);
          const parsedParams: Partial<ParsedParams> = {};
          for (let [key, value] of searchParams.entries()) {
            try {
              parsedParams[key as keyof ParsedParams] = JSON.parse(value);
            } catch (e) {
              parsedParams[key as keyof ParsedParams] = value;
            }
          }
          this.customSenderInfo = this.customSenderInfo || {};
          this.memberDetails = this.memberDetails || {};
          this.b2b_shipment = this.b2b_shipment || {};
          this.selectedShipment = this.selectedShipment || {};
          if (parsedParams.company_id) this.selectedShipment.company_id = parsedParams.company_id;
          if (parsedParams.service_type) this.selectedShipment.service_type = parsedParams.service_type;
          if (parsedParams.vendor) this.selectedShipment.vendor = parsedParams.vendor;
          if (parsedParams.b2b_shipment_number) this.b2b_shipment.shipment_number = parsedParams.b2b_shipment_number;
          // if (parsedParams.promoCode) this.discountCode = parsedParams.promoCode;
          if (parsedParams.b2b_recipient_id) this.b2b_shipment.b2b_recipient_id = parsedParams.b2b_recipient_id;
          if (parsedParams.b2b_shipment_id) this.b2b_shipment.id = parsedParams.b2b_shipment_id;
          if (parsedParams.shopper_email) this.form.patchValue({ emailAddress: parsedParams.shopper_email })
          if (parsedParams.b2b_user_email) this.memberDetails.email = parsedParams.b2b_user_email;
          if (parsedParams.from_address_id) this.customSenderInfo.id = parsedParams.from_address_id;
          if (parsedParams.to_address) this.form.patchValue({
            recipient: parsedParams.to_address['name'],
            addressLineOne: parsedParams.to_address['street1'],
            addressLineTwo: parsedParams.to_address['street2'],
            cityName: parsedParams.to_address['city'],
            state: parsedParams.to_address['state'],
            postCode: parsedParams.to_address['zip'],
            country: parsedParams.to_address['country'],
            phoneNumber: parsedParams.to_address['phone'],
            emailAddress: parsedParams.to_address['email'],
            companyName: parsedParams.to_address['company'],
          });
          if (parsedParams.from_address)
            this.customSenderInfo.senderName = parsedParams.from_address['name'];
          this.customSenderInfo.senderEmail = parsedParams.from_address['email'];
          this.customSenderInfo.addressLineOne = parsedParams.from_address['street1'];
          this.customSenderInfo.addressLineTwo = parsedParams.from_address['street2'];
          this.customSenderInfo.cityName = parsedParams.from_address['city'];
          this.customSenderInfo.state = parsedParams.from_address['state'];
          this.customSenderInfo.postCode = parsedParams.from_address['zip'];
          this.customSenderInfo.country = parsedParams.from_address['country'];
          this.customSenderInfo.senderPhone = parsedParams.from_address['phone'];
          if (parsedParams.parcel) {
            this.parcelAndLabelOptionsForm.patchValue({
              length: parsedParams.parcel['length'].toString(),
              width: parsedParams.parcel['width'],
              height: parsedParams.parcel['height'],
              weight: parsedParams.parcel['weight'],
              weightUnit: parsedParams.parcel['weight_unit'] == 'lbs' ? 'Pound' : 'Kilogram',
              dimensionUnit: parsedParams.parcel['dimension_unit'] == 'cm' ? 'Centimeter' : 'Inch',
            });
          }
          if (parsedParams.customs_info) {
            this.customsForm.patchValue({
              customsItems: parsedParams.customs_info['customs_items']
            });
          }
          if (parsedParams.options) {
            this.parcelAndLabelOptionsForm.patchValue({
              labelFormat: parsedParams.options['label_format'],
              invoiceNumber: parsedParams.options['invoice_number']
            });
          }
          if (parsedParams.insurance) this.insuranceSelected = parsedParams.insurance;
          if (parsedParams.insurance_exists) this.insuranceSelected = parsedParams.insurance_exists;
          this.stripePaymentConfirm(paramPaymentIntent);
        } catch (error) {
        }
      }
    })
    this.watcherService.getLang().subscribe(
      lang => {
        this.lang = lang;
      }
    )
    this.store.select('auth').subscribe(state => {
      this.token = state.token;
      this.userID = state.user?.id;
      let activeUser = state.user;
      if (this.userID) {
        this.comingFromContactus = false;
        if (!activeUser?.is_b2b_user_active) {
          if (!this.lang) {
            this.lang = 'en';
          }
          this.router.navigate(['/','b2b', 'shipments'])
        } else {
          this.signUpService.getUserCreditCards(this.token).subscribe({
            next: data => {
              if (data["result"]["status"] != 200) {
                this.toastr.error('Error', data["result"]["message"]);
              }
              else {
                this.userCreditCardData = data["data"];
                if (this.userCreditCardData?.length > 0) {
                  // Listed Cards 
                  this.userCreditCardDataArray = this.userCreditCardData.filter(creditCard => {
                    return creditCard.list_card == 1 && creditCard.status > 0 && !creditCard.wallet;
                  });
                  // Verified Cards
                  const verifiedCreditCard = this.userCreditCardDataArray.filter(creditCard => {
                    return creditCard.status == 3;
                  });
                  const unVerifiedCreditCard = this.userCreditCardDataArray.filter(creditCard => {
                    return creditCard.status == 1 || (creditCard.status == 2 && creditCard.verification_attempts < 2);
                  });

                  const verified3dSecureCreditCard = this.userCreditCardDataArray.filter(creditCard => {
                    return creditCard.payment_method_id != "";
                  });
                  if (verified3dSecureCreditCard.length > 0) {
                    const lastVerifiedCreditCard = verified3dSecureCreditCard.reduce(
                      function (prev, current) {
                        return (prev.date > current.date) ? prev : current;
                      }
                    )
                    this.selectedCreditCard = lastVerifiedCreditCard;
                    this.selectedCreditCardID = lastVerifiedCreditCard.id;
                    this.paymentMethod = 'credit_card';
                  }
                  if (verified3dSecureCreditCard.length < 1 && verifiedCreditCard.length > 0) {
                    const lastVerifiedCreditCard = verifiedCreditCard.reduce(
                      function (prev, current) {
                        return (prev.date > current.date) ? prev : current;
                      }
                    )
                    this.selectedCreditCard = lastVerifiedCreditCard;
                    this.selectedCreditCardID = lastVerifiedCreditCard.id;
                    this.paymentMethod = 'credit_card';
                  }

                  if (verified3dSecureCreditCard.length < 1 && verifiedCreditCard.length < 1 && unVerifiedCreditCard.length > 0) {
                    this.showAddCardForm = false;
                    const lastunVerifiedCreditCard = unVerifiedCreditCard.reduce(
                      function (prev, current) {
                        return (prev.date > current.date) ? prev : current;
                      }
                    )
                    this.selectedCreditCard = lastunVerifiedCreditCard;
                    this.selectedCreditCardID = lastunVerifiedCreditCard.id;
                    this.paymentMethod = 'credit_card';
                  }
                } else {
                  this.paymentMethod = 'stripe';
                  this.showAddCardForm = false;
                }
              }
            }
          })
        }
      } else {
        this.comingFromContactus = true;
      }
    })
    this.signUpService.getAllCountries().subscribe(list => {
      this.allCountries = list["data"];
    })
    this.testMask = this.getMaskbyCountry(this.form.value.country, this.codeMaskList);
    this.customsForm.controls.eelOrPfcNumber.disable();
    this.customsForm.controls.restrictionType.disable();
    this.customsForm.controls.nonDeliveryAction.disable();
    this.parcelAndLabelOptionsForm.controls.labelFormat.disable();

    this.form.statusChanges.subscribe(status => {
      if (status == "VALID") {
        if (this.customSenderInfo['id']) {
          this.step1isValid = true;
        } else {
          if (this.customSenderInfo.senderName) {
            this.step1isValid = true;
          } else {
            this.step1isValid = false;
          }
        }
      } else {
        this.step1isValid = false;
      }
      this.checkUserMoveCap();

    })
    this.customsForm.statusChanges.subscribe(status => {
      if (status == "VALID" && this.customsForm.value.customsItems) {
        this.step2isValid = true;
      } else {
        this.step2isValid = false;
      }
      this.checkUserMoveCap();
    })
    this.parcelAndLabelOptionsForm.statusChanges.subscribe(status => {
      if (status == "VALID") {
        this.step3isValid = true;
      } else {
        this.step3isValid = false;
      }
      this.checkUserMoveCap();
    })
    // Init Stripe
    let paymentRequest = this.paymentRequestM;
    let stripe = Stripe(this.stripeClientSecret);
    const reqElements = stripe.elements();
    // Payment Request 
    const prButton = reqElements.create('paymentRequestButton', {
      paymentRequest,
    });
    // Check the availability of the Payment Request API first.
    paymentRequest.canMakePayment().then(function (result) {
      if (result) {
        prButton.mount('#payment-request-button');
      } else {

        const paymentRequestButton = document.getElementById('payment-request-button');
        const googlePayBox = document.getElementById('googlePay-box');
        const paypalBox = document.getElementById('paypal-box');
        if (paymentRequestButton) {
          paymentRequestButton.style.display = 'none';
        }
        if (googlePayBox) {
          googlePayBox.style.display = 'none';
        }
        if (paypalBox) {
          paypalBox.style.border = '0';
        }
      }
    });
    paymentRequest.on('paymentmethod', (ev) => {
      this.isLoading = true;
      this.signUpService.getUserByUserID(this.userID, this.token).subscribe();

      var userDataGooglePay = {
        company_id: this.selectedShipment.company_id,
        payment_with_paypal: 0,
        paypal: "",
        promo_code: "",
        service_type: this.selectedShipment.service_type,
        vendor: this.selectedShipment.vendor,
        payment_with_stripe3ds: 1,
        payment_method_type: ["card", "klarna"],
        google_pay: 1,
        customer: this.selectedCreditCard?.customer,
        b2b_shipment_number: this.b2b_shipment.shipment_number,
        b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
        shopper_email: this.form.value.emailAddress,
        b2b_user_email: this.memberDetails.email,
        from_address_id: this.customSenderInfo['id'],
        to_address: {
          name: this.form.value.recipient,
          street1: this.form.value.addressLineOne,
          street2: this.form.value.addressLineTwo,
          city: this.form.value.cityName,
          state: this.form.value.state,
          zip: this.form.value.postCode,
          country: this.form.value.country,
          phone: this.form.value.phoneNumber,
          email: this.form.value.emailAddress,
          company: this.form.value.companyName,
        },
        from_address: {
          name: this.customSenderInfo.senderName,
          street1: this.customSenderInfo.addressLineOne,
          street2: this.customSenderInfo.addressLineTwo,
          city: this.customSenderInfo.cityName,
          state: this.customSenderInfo.state,
          zip: this.customSenderInfo.postCode,
          country: this.customSenderInfo.country,
          phone: this.customSenderInfo.senderPhone,
          email: this.customSenderInfo.senderEmail
        },
        parcel: {
          length: this.parcelAndLabelOptionsForm.value.length,
          width: this.parcelAndLabelOptionsForm.value.width,
          height: this.parcelAndLabelOptionsForm.value.height,
          weight: this.parcelAndLabelOptionsForm.value.weight,
          weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
          dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
        },
        customs_info: {
          customs_items: this.customsForm.value.customsItems
        },
        options: {
          eel_pfc: this.customsForm.value.eelOrPfcNumber,
          restriction_type: this.customsForm.value.restrictionType,
          contents_type: this.customsForm.value.contentType,
          contents_explanation: this.customsForm.value.explanationOfContent,
          label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
          invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
        },
        insurance: parseInt(this.insuranceSelected),
        insurance_exists: parseInt(this.insuranceSelected),
      }

      this.signUpService.confirmB2BOrder(this.token, userDataGooglePay).pipe(
        switchMap((data) => {
          if (data["result"]["status"] == 200) {
            const stripe = Stripe(this.stripeClientSecret);
            return stripe.confirmCardPayment(data['data']['client_secret'], { payment_method: ev.paymentMethod.id },
              { handleActions: false }).then(function (result) {
                if (result.error) {
                  return result;
                } else {
                  if (result.paymentIntent.status === 'succeeded') {
                    return data;
                  }
                }
                return result;
              });
          }
        }),
        catchError(err => {
          return err;
        })
      ).subscribe(async dataAfterPi => {





        var confirmGPayData = {
          company_id: this.selectedShipment.company_id ? this.selectedShipment.company_id : 0,
          payment_with_paypal: 0,
          paypal: "",
          promo_code: "",
          service_type: this.selectedShipment.service_type ? this.selectedShipment.service_type : "",
          vendor: this.selectedShipment.vendor ? this.selectedShipment.vendor : "",
          payment_with_stripe3ds: 1,
          payment_method_type: ["card", "klarna"],
          google_pay: 1,
          b2b_shipment_number: this.b2b_shipment.shipment_number ? this.b2b_shipment.shipment_number : "",
          b2b_recipient_id: this.b2b_shipment.b2b_recipient_id ? this.b2b_shipment.b2b_recipient_id : "",
          shopper_email: this.form.value.emailAddress ? this.form.value.emailAddress : "",
          b2b_user_email: this.memberDetails.email ? this.memberDetails.email : "",
          from_address_id: this.customSenderInfo['id'] ? this.customSenderInfo['id'] : "",
          to_address: {
            name: this.form.value.recipient ? this.form.value.recipient : "",
            street1: this.form.value.addressLineOne ? this.form.value.addressLineOne : "",
            street2: this.form.value.addressLineTwo ? this.form.value.addressLineTwo : "",
            city: this.form.value.cityName ? this.form.value.cityName : "",
            state: this.form.value.state ? this.form.value.state : "",
            zip: this.form.value.postCode ? this.form.value.postCode : "",
            country: this.form.value.country ? this.form.value.country : "",
            phone: this.form.value.phoneNumber ? this.form.value.phoneNumber : "",
            email: this.form.value.emailAddress ? this.form.value.emailAddress : "",
            company: this.form.value.companyName ? this.form.value.companyName : "",
          },
          from_address: {
            name: this.customSenderInfo.senderName ? this.customSenderInfo.senderName : "",
            street1: this.customSenderInfo.addressLineOne ? this.customSenderInfo.addressLineOne : "",
            street2: this.customSenderInfo.addressLineTwo ? this.customSenderInfo.addressLineTwo : "",
            city: this.customSenderInfo.cityName ? this.customSenderInfo.cityName : "",
            state: this.customSenderInfo.state ? this.customSenderInfo.state : "",
            zip: this.customSenderInfo.postCode ? this.customSenderInfo.postCode : "",
            country: this.customSenderInfo.country ? this.customSenderInfo.country : "",
            phone: this.customSenderInfo.senderPhone ? this.customSenderInfo.senderPhone : "",
            email: this.customSenderInfo.senderEmail ? this.customSenderInfo.senderEmail : ""
          },
          parcel: {
            length: this.parcelAndLabelOptionsForm.value.length ? this.parcelAndLabelOptionsForm.value.length : "",
            width: this.parcelAndLabelOptionsForm.value.width ? this.parcelAndLabelOptionsForm.value.width : "",
            height: this.parcelAndLabelOptionsForm.value.height ? this.parcelAndLabelOptionsForm.value.height : "",
            weight: this.parcelAndLabelOptionsForm.value.weight ? this.parcelAndLabelOptionsForm.value.weight : "",
            weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
            dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
          },
          customs_info: {
            customs_items: this.customsForm.value.customsItems ? this.customsForm.value.customsItems : ""
          },
          options: {
            eel_pfc: this.customsForm.value.eelOrPfcNumber ? this.customsForm.value.eelOrPfcNumber : "NOEEI 30.37(a)",
            restriction_type: this.customsForm.value.restrictionType ? this.customsForm.value.restrictionType : "None",
            contents_type: this.customsForm.value.contentType ? this.customsForm.value.contentType : "Merchandise",
            contents_explanation: this.customsForm.value.explanationOfContent ? this.customsForm.value.explanationOfContent : "",
            label_format: this.parcelAndLabelOptionsForm.value.labelFormat ? this.parcelAndLabelOptionsForm.value.labelFormat : "PDF",
            invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber ? this.parcelAndLabelOptionsForm.value.invoiceNumber : ""
          },
          payment_intent: dataAfterPi['paymentIntent']['id'] ? dataAfterPi['paymentIntent']['id'] : "",
          insurance: parseInt(this.insuranceSelected),
          insurance_exists: parseInt(this.insuranceSelected),
        }
        this.signUpService.confirmB2BOrder(this.token, confirmGPayData).subscribe(data => {
          if (data['result']['status'] == 200) {
            this.toastr.success(data["result"]["message"], 'Success');
            this.signUpService.getB2BShipmentDetailViaID(this.token, this.b2b_shipment.id).subscribe({
              next: (getShipmentRes) => {
                this.paymentDone = true;
                this.sendGTMSuccessEvent(getShipmentRes['data']);
                this.paymentCompletedShipment = getShipmentRes['data'];
                this.currentStep = 4;
                this.checkUserMoveCap();
                this.shipment_awb_no = getShipmentRes['data']['awb_no'];
                window.scrollTo(0, 0);
              }
            })

            // this.$gaService.event(data["data"]["country_from"] + "-" + data["data"]["country_to"], "Order Success", data["data"]["shopper"]["email"], this.orderAmount.shipment_amount_after_discount)
            localStorage.setItem('GAEventOrderID', data["data"]["id"])
            this.router.navigate(['/','member', 'order-success', data["data"]["id"]])
            //this.isLoading = false;
          } else {
            this.isLoading = false;
            this.toastr.error('Payment Error', 'Error');
            if (data["result"]["status"] == 930 || data["result"]["status"] == 931) {
              this.openErrorDialog();

            }
          }
        })

      });
    });
  }
  public handleAddressChange(address: any, formType) {

    this.formattedAddress = address.formatted_address;
    this.fillInAddress(address, formType)
  }
  fillInAddress(place, formType) {
    const addressNameFormat = {
      'street_number': 'short_name',
      'route': 'long_name',
      'locality': 'long_name',
      'administrative_area_level_1': 'long_name',
      'administrative_area_level_4': 'long_name',
      'administrative_area_level_2': 'long_name',
      'country': 'short_name',
      'postal_code': 'short_name',
    };

    const componentForm = [
      'location',
      'locality',
      'administrative_area_level_1',
      'administrative_area_level_4',
      'administrative_area_level_2',
      'country',
      'postal_code',
    ];
    const getAddressComp = function (type) {
      for (const component of place.address_components) {
        if (component.types[0] === type) {
          return component[addressNameFormat[type]];
        }
      }
      return '';
    };

    var googleDBCountry = getAddressComp('country')
    var replacedCountry = "";
    var hasCountryInShippnDB = this.allCountries.filter(item => {
      return item.code == googleDBCountry;
    })

    if (googleDBCountry == "GB") {
      replacedCountry = "UK";
    }
    else if (hasCountryInShippnDB.length == 0) {
      replacedCountry = "";
    }
    else {
      replacedCountry = googleDBCountry;
    }

    this.form.patchValue({
      addressLineOne: this.latinCharService.replaceNonLatinCharacters(getAddressComp('street_number')) + ' '
        + this.latinCharService.replaceNonLatinCharacters(getAddressComp('route')) + ' '
        + this.latinCharService.replaceNonLatinCharacters(getAddressComp('administrative_area_level_4')),
      //addressLineTwo: address.line2,
      country: replacedCountry,
      cityName: this.latinCharService.replaceNonLatinCharacters(getAddressComp('administrative_area_level_2')),
      state: this.latinCharService.replaceNonLatinCharacters(getAddressComp('administrative_area_level_1')),
      postCode: getAddressComp('postal_code'),
    })



    // document.getElementById('location').value = getAddressComp('street_number') + ' '
    //           + getAddressComp('route');
    for (const component of componentForm) {
      // Location field is handled separately above as it has different logic.
      if (component !== 'location') {
        //document.getElementById(component).value = getAddressComp(component);
      }
      if (component == 'postal_code') {
        this.testMask = this.getMaskbyCountry(replacedCountry, this.codeMaskList)
      }
    }

  }
  getMaskbyCountry(c, a) {
    for (var i = a.length - 1; i >= 0; i--) {
      if (a[i].code == c) return a[i].mask;
    }
    return '';
  }

  changeAddCountry() {
    this.testMask = this.getMaskbyCountry(this.form.value.country, this.codeMaskList)
  }
  checkInputValidationsAddress() {
    var hasError = false;

    if (this.form.controls.recipient.status == "INVALID") {
      this.form.controls.recipient.markAsTouched()
      hasError = true;
    }
    if (this.form.controls.companyName.status == "INVALID") {
      this.form.controls.companyName.markAsTouched()
      hasError = true;
    }
    if (this.form.controls.emailAddress.status == "INVALID") {
      this.form.controls.emailAddress.markAsTouched()
      hasError = true;
    }
    if (this.form.controls.phoneNumber.status == "INVALID") {
      this.form.controls.phoneNumber.markAsTouched()
      hasError = true;
    }

    if (this.form.controls.addressLineOne.status == "INVALID") {
      this.form.controls.addressLineOne.markAsTouched()
      hasError = true;
    }
    if (this.form.controls.country.status == "INVALID") {
      this.form.controls.country.markAsTouched()
      hasError = true;
    }
    if (this.form.controls.cityName.status == "INVALID") {
      this.form.controls.cityName.markAsTouched()
      hasError = true;
    }
    if (this.form.controls.postCode.status == "INVALID") {
      this.form.controls.postCode.markAsTouched()
      hasError = true;
    }
    return hasError;
  }
  minDate: Date = new Date();
  maxDate: Date;
  selectedDate: Date;
  @ViewChild('picker') picker: MatDatepicker<Date>;

  dateSelected(ev) {
    this.selectedDate = new Date(ev.value);

  }
  addCustomsItems() {

  }
  changeWeightUnitOfParcelInformation(unit) {
    this.parcelAndLabelOptionsForm.controls.weightUnit.setValue(unit)
  }
  changeDimensionUnitOfParcelInformation(unit) {
    this.parcelAndLabelOptionsForm.controls.dimensionUnit.setValue(unit.dimensionUnit)
    this.parcelAndLabelOptionsForm.controls.weightUnit.setValue(unit.weightUnit)
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(AddItemForCustomsDialog, { data: this.htsList, disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.addCustomItem(result)
      }
    });
  }
  openChangeSenderDialog(): void {
    const dialogSenderRef = this.dialog.open(ChangeSenderInfoDialog, { disableClose: true });
    dialogSenderRef.afterClosed().subscribe(result => {
      if (result) {
        this.customSenderInfo = result.customSenderInfo;
        if (this.userID && this.memberDetails) {
          this.memberDetails.addresses = result.updatedAddresses;
          if (this.customSenderInfo['id'] && this.form.status === "VALID") {
            this.step1isValid = true;
            this.checkUserMoveCap();
          }
        } else {
          this.customsForm.controls.signature.setValue(`${this.customSenderInfo.senderName}`)
          if (this.form.status === "VALID") {
            this.step1isValid = true;
            this.checkUserMoveCap();
          }
        }
      }
    });
  }
  openSelectSenderDialog(): void {
    const senderAddresses = this.memberDetails.addresses;
    const dialogSenderRef = this.dialog.open(SelectSenderInfoDialog, { data: senderAddresses, disableClose: true });
    dialogSenderRef.afterClosed().subscribe(result => {
      if (result) {
        this.customSenderInfo = result;
        if (this.customSenderInfo['id'] && this.form.status === "VALID") {
          this.step1isValid = true;
          this.checkUserMoveCap();
        }
      }
    });
  }

  openErrorDialog(): void {
    const dialogRef = this.dialog.open(CreateShipmentErrorDialog, { disableClose: true })
    dialogRef.afterClosed().subscribe(result => {

    })
  }

  checkItemIsUnique(item) {
    if (this.customsForm.value.customsItems.length == 0) {
      return true;
    }
  }
  addCustomItem(item) {

    let index = this.customsForm.value.customsItems.findIndex(x => x.description == item.description && x.origin_country == item.origin_country && x.weight == item.weight && x.value == item.value && x.currency == item.currency && x.hs_tariff_number == item.hs_tariff_number);

    let tempCustomsItemArr = this.customsForm.value.customsItems;
    if (index == -1) {
      tempCustomsItemArr.push(item);
    } else {
      tempCustomsItemArr[index].quantity += item.quantity
    }
    this.customsForm.controls.customsItems.setValue(tempCustomsItemArr);
  }
  removeCustomsItem(index) {

    if (this.customsForm.value.customsItems.length > 0) {

      let tempCustomItemsArr = this.customsForm.value.customsItems;
      tempCustomItemsArr.splice(index, 1);
      this.customsForm.controls.customsItems.setValue(tempCustomItemsArr)
    } else {
      this.customsForm.controls.customsItems.setValue([])
    }

  }

  openEditCustomDialog(item, index) {

    let dataToDialog = {
      item: item,
      htsList: this.htsList
    }
    const dialogRef = this.dialog.open(EditItemForCustomsDialog, { data: dataToDialog, disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.editCustomItem(result, index)
      }
    });
  }

  editCustomItem(item, index) {

    let tempCustomsItemArr = this.customsForm.value.customsItems;

    tempCustomsItemArr[index] = item;
    this.customsForm.controls.customsItems.setValue(tempCustomsItemArr);

  }

  moveNextStep() {
    let shipmentBookingData;
    if (!this.userID) {
      switch (this.currentStep) {
        case 0:
          shipmentBookingData = {
            step0: {
              customSenderInfo: this.customSenderInfo,
              form: this.form.value,
            }
          }
          localStorage.setItem('shipmentBookingData', JSON.stringify(shipmentBookingData));
          break;
        case 1:
          shipmentBookingData = {
            step0: {
              customSenderInfo: this.customSenderInfo,
              form: this.form.value,
            },
            step1: {
              customsForm: this.customsForm.value
            }
          }
          localStorage.setItem('shipmentBookingData', JSON.stringify(shipmentBookingData));
          break;
        case 2:
          shipmentBookingData = {
            step0: {
              customSenderInfo: this.customSenderInfo,
              form: this.form.value,
            },
            step1: {
              customsForm: this.customsForm.value
            },
            step2: {
              parcelAndLabelOptionsForm: this.parcelAndLabelOptionsForm.value
            }
          }
          localStorage.setItem('shipmentBookingData', JSON.stringify(shipmentBookingData));
          break;

      }
    }
    if (this.currentStep == 2) {
      if (this.userID && this.memberDetails) {
        this.getB2BAmaountListViaPayload();
      } else {
        this.getB2BPriceForPossibleUser();
      }
    } else {
      this.currentStep += 1;
      if (this.stepper) {
        this.stepper.selectedIndex = this.currentStep;
      }
      this.checkUserMoveCap();
      this.cdr.detectChanges();
    }
  }
  hasCourierOptions;
  courierData;
  getB2BPriceForPossibleUser() {
    const payload = {
      country_to: this.form.value.country,
      country_from: this.customSenderInfo.country,
      weight: this.parcelAndLabelOptionsForm.value.weight,
      weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
      height: this.parcelAndLabelOptionsForm.value.height,
      width: this.parcelAndLabelOptionsForm.value.width,
      length: this.parcelAndLabelOptionsForm.value.length,
      dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
    };
    this.signUpService.getB2BPriceList('', payload).subscribe({
      next: (calculateRes) => {
        if (calculateRes['data'].length > 0) {
          this.hasCourierOptions = true;

          const filteredData = calculateRes['data'].map((item) => {
            return {
              ...item,
              amount: item.amount.toFixed(2)
            };
          });
          this.courierData = filteredData;

          this.shipment_amounts = this.courierData;
          this.selectedShipment = this.shipment_amounts[0];
          if (this.courierData.length > 0) {
            this.currentStep = 3;
            this.checkUserMoveCap();
          }
        } else {
          this.toastr.error(calculateRes['result']['message'], "Error")
        }
      },
      error: (err) => { },
    });
  }
  goToB2BSignupWithShipment() { }
  movePrevStep() {
    this.currentStep -= 1;
    this.insuranceSelected = "0";
    this.checkUserMoveCap();
  }
  userCanMoveBackward = true;
  userCanMoveForward = false;
  shipment_awb_no
  checkUserMoveCap() {
    switch (this.currentStep) {
      case 0:
        this.step1isValid ? this.userCanMoveForward = true : this.userCanMoveForward = false
        break;
      case 1:
        this.step2isValid ? this.userCanMoveForward = true : this.userCanMoveForward = false
        break;
      case 2:
        this.step3isValid ? this.userCanMoveForward = true : this.userCanMoveForward = false
        break;
      case 3:
        this.step4isValid ? this.userCanMoveForward = true : this.userCanMoveForward = false
      case 4:
        this.shipment_awb_no ? this.userCanMoveBackward = false : this.userCanMoveBackward = true;
        break;
    }
  }
  // Payment Start
  b2b_shipment: b2bShipmentData;
  shipment_amounts: b2bShipmentAmount[] = [{
    shipment_amount: 0,
    emergency_situation_surcharge: 0,
    peak_surcharge: 0,
    fuel_surcharge_rate: 0,
    vendor: "",
    company_id: 0,
    service_type: 0,
    service_type_name: "",
    restricted_destination_fee: 0,
    elevated_risk_fee: 0,
    non_standard_pickup_fee: 0,
    total_shipment_amount: 0,
    estimated_delivery: "",
    extended_area_amount: 0,
    additional_handling_surcharge: 0,
    oversize_package_fee: 0,
    residential_delivery_charge: 0,
    brexit_fee: 0,
    export_declaration_fee: 0,
    repacking_service_fee: 0
  }];

  courierList = [
    "",
    "TNT",
    "UPS",
    "DHL",
    "FedEx",
    "AusPost",
    "USPS",
    "Aramex",
    "LaPoste",
    "ChronoPost",
    "PostNord",
    "MNG",
    "EMS",
    "DPD",
    "Evri"
  ]
  getB2BAmaountListViaPayload() {
    let payload = {
      b2b_user_email: this.memberDetails.email,
      from_address_id: this.customSenderInfo['id'],
      to_address: {
        name: this.form.value.recipient,
        street1: this.form.value.addressLineOne,
        street2: this.form.value.addressLineTwo,
        city: this.form.value.cityName,
        state: this.form.value.state,
        zip: this.form.value.postCode,
        country: this.form.value.country,
        phone: this.form.value.phoneNumber,
        email: this.form.value.emailAddress,
        company: this.form.value.companyName,
      },
      parcel: {
        length: this.parcelAndLabelOptionsForm.value.length,
        width: this.parcelAndLabelOptionsForm.value.width,
        height: this.parcelAndLabelOptionsForm.value.height,
        weight: this.parcelAndLabelOptionsForm.value.weight,
        weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
        dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
      },
      customs_info: {
        customs_items: this.customsForm.value.customsItems
      },
      insurance: parseInt(this.insuranceSelected),
    }
    this.signUpService.getB2BAmount(this.token, payload).subscribe({
      next: res => {
        if (res['result']['status'] == 200 && res['data']['shipment_amount'].length > 0) {
          this.shipment_amounts = res['data']['shipment_amount'];
          this.selectedShipment = this.shipment_amounts[0];
          this.insuranceAmount = parseFloat(res['data']['insurance']);
          this.b2b_shipment = res['data']['b2b_shipment'];
          this.createdShipmentID = this.b2b_shipment.id;
          this.drawStripePaymentElement();
          this.drawGooglePayButton();

          // Update step and force change detection
          this.currentStep = 3;
          if (this.stepper) {
            this.stepper.selectedIndex = this.currentStep;
            this.stepper.linear = false;
            setTimeout(() => {
              this.stepper.linear = true;
              this.cdr.detectChanges();
            });
          }

          this.checkUserMoveCap();
          localStorage.getItem('shipmentBookingData') ? localStorage.removeItem('shipmentBookingData') : '';
        } else if(res['data']['shipment_amount'].length === 0 || !res['data']['shipment_amount']){
          this.toastr.error("There is no available carrier for this shipment", "Error")
        } else {
          this.toastr.error(res['result']['message'], "Error")
        }
      },
      error: err => {
        if (err.error.message) {
          this.toastr.error(err.error.message, "Error");
        } else {
          this.toastr.error("An error occured", "Error")
        }
      }
    })
  }
  selectedCourier;
  selectedCourierID = 0;
  bestOptionSelected = true;
  selectedShipment;
  changeCourier(courierID, index) {
    this.selectedShipment = this.shipment_amounts[index];
    this.selectedCourier = index;
    this.selectedCourierID = courierID;
    if (index !== 0) {
      this.bestOptionSelected = false;
    } else {
      this.bestOptionSelected = true;
    }
    if (this.userID && this.token) {
      this.updatePaymentIntent()
    }
  }
  updateAmount() {
    let payload = {
      b2b_user_email: this.memberDetails.email,
      from_address_id: this.customSenderInfo['id'],
      to_address: {
        name: this.form.value.recipient,
        street1: this.form.value.addressLineOne,
        street2: this.form.value.addressLineTwo,
        city: this.form.value.cityName,
        state: this.form.value.state,
        zip: this.form.value.postCode,
        country: this.form.value.country,
        phone: this.form.value.phoneNumber,
        email: this.form.value.emailAddress,
        company: this.form.value.companyName,
      },
      parcel: {
        length: this.parcelAndLabelOptionsForm.value.length,
        width: this.parcelAndLabelOptionsForm.value.width,
        height: this.parcelAndLabelOptionsForm.value.height,
        weight: this.parcelAndLabelOptionsForm.value.weight,
        weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
        dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
      },
      customs_info: {
        customs_items: this.customsForm.value.customsItems
      },
      insurance: parseInt(this.insuranceSelected),
      insurance_exists: parseInt(this.insuranceSelected),
    }
    this.signUpService.getB2BAmount(this.token, payload).subscribe({
      next: res => {
        if (res['result']['status'] == 200 && res['data']['shipment_amount'].length > 0) {
          this.shipment_amounts = res['data']['shipment_amount'];
          if (this.selectedCourier) {
            this.selectedShipment = this.shipment_amounts[this.selectedCourier];
          } else {
            this.selectedShipment = this.shipment_amounts[0];
          }
          this.updatePaymentIntent();
        } else if(res['data']['shipment_amount'].length === 0 || !res['data']['shipment_amount']){
          this.toastr.error("There is no available carrier for this shipment", "Error")
        } else {
          this.toastr.error(res['result']['message'], "Error")
        }
      },
      error: err => {
        if (err.error.message) {
          this.toastr.error(err.error.message, "Error");
        } else {
          this.toastr.error("An error occured", "Error")
        }
      }
    })
  }

  updatePaymentIntent() {
    var userData3d;
    if (this.selectedShipment.shipment_id && this.selectedShipment.shipment_id.includes('-')) {
      userData3d = {
        payment_with_paypal: 0,
        paypal: "",
        promo_code: "",
        payment_with_stripe3ds: 1,
        payment_method_type: ["card", "klarna"],
        company_id: this.selectedShipment.company_id,
        service_type: this.selectedShipment.service_type,
        vendor: this.selectedShipment.vendor,
        b2b_shipment_number: this.b2b_shipment.shipment_number,
        b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
        shopper_email: this.form.value.emailAddress,
        b2b_user_email: this.memberDetails.email,
        from_address_id: this.customSenderInfo['id'],
        to_address: {
          name: this.form.value.recipient,
          street1: this.form.value.addressLineOne,
          street2: this.form.value.addressLineTwo,
          city: this.form.value.cityName,
          state: this.form.value.state,
          zip: this.form.value.postCode,
          country: this.form.value.country,
          phone: this.form.value.phoneNumber,
          email: this.form.value.emailAddress,
          company: this.form.value.companyName,
        },
        from_address: {
          name: this.customSenderInfo.senderName,
          street1: this.customSenderInfo.addressLineOne,
          street2: this.customSenderInfo.addressLineTwo,
          city: this.customSenderInfo.cityName,
          state: this.customSenderInfo.state,
          zip: this.customSenderInfo.postCode,
          country: this.customSenderInfo.country,
          phone: this.customSenderInfo.senderPhone,
          email: this.customSenderInfo.senderEmail
        },
        parcel: {
          length: this.parcelAndLabelOptionsForm.value.length,
          width: this.parcelAndLabelOptionsForm.value.width,
          height: this.parcelAndLabelOptionsForm.value.height,
          weight: this.parcelAndLabelOptionsForm.value.weight,
          weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
          dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
        },
        customs_info: {
          customs_items: this.customsForm.value.customsItems
        },
        update_payment_intent: 1,
        insurance: parseInt(this.insuranceSelected),
        insurance_exists: parseInt(this.insuranceSelected),
        rate_id: this.selectedShipment.rate_id ? this.selectedShipment.rate_id : '',
        service: this.selectedShipment.rate_service ? this.selectedShipment.rate_service : '',
        options: {
          eel_pfc: this.customsForm.value.eelOrPfcNumber,
          restriction_type: this.customsForm.value.restrictionType,
          contents_type: this.customsForm.value.contentType,
          contents_explanation: this.customsForm.value.explanationOfContent,
          label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
          invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
        }

      }
    } else {
      userData3d = {
        payment_with_paypal: 0,
        paypal: "",
        promo_code: "",
        payment_with_stripe3ds: 1,
        payment_method_type: ["card", "klarna"],
        company_id: this.selectedShipment.company_id,
        service_type: this.selectedShipment.service_type,
        vendor: this.selectedShipment.vendor,
        b2b_shipment_number: this.b2b_shipment.shipment_number,
        b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
        shopper_email: this.form.value.emailAddress,
        b2b_user_email: this.memberDetails.email,
        from_address_id: this.customSenderInfo['id'],
        to_address: {
          name: this.form.value.recipient,
          street1: this.form.value.addressLineOne,
          street2: this.form.value.addressLineTwo,
          city: this.form.value.cityName,
          state: this.form.value.state,
          zip: this.form.value.postCode,
          country: this.form.value.country,
          phone: this.form.value.phoneNumber,
          email: this.form.value.emailAddress,
          company: this.form.value.companyName,
        },
        from_address: {
          name: this.customSenderInfo.senderName,
          street1: this.customSenderInfo.addressLineOne,
          street2: this.customSenderInfo.addressLineTwo,
          city: this.customSenderInfo.cityName,
          state: this.customSenderInfo.state,
          zip: this.customSenderInfo.postCode,
          country: this.customSenderInfo.country,
          phone: this.customSenderInfo.senderPhone,
          email: this.customSenderInfo.senderEmail
        },
        parcel: {
          length: this.parcelAndLabelOptionsForm.value.length,
          width: this.parcelAndLabelOptionsForm.value.width,
          height: this.parcelAndLabelOptionsForm.value.height,
          weight: this.parcelAndLabelOptionsForm.value.weight,
          weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
          dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
        },
        customs_info: {
          customs_items: this.customsForm.value.customsItems
        },
        update_payment_intent: 1,
        insurance: parseInt(this.insuranceSelected),
        insurance_exists: parseInt(this.insuranceSelected),
        rate_id: this.selectedShipment.rate_id ? this.selectedShipment.rate_id : '',
        service: this.selectedShipment.rate_service ? this.selectedShipment.rate_service : '',
        options: {
          eel_pfc: this.customsForm.value.eelOrPfcNumber,
          restriction_type: this.customsForm.value.restrictionType,
          contents_type: this.customsForm.value.contentType,
          contents_explanation: this.customsForm.value.explanationOfContent,
          label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
          invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
        }

      }
    }
    this.signUpService.confirmB2BOrder(this.token, userData3d).subscribe({
      next: data => {
        if (data['result']['status'] === 200) {
          this.paymentRequestM.update({
            total: {
              label: this.b2b_shipment.shipment_number,
              amount: Number(data['data']['amount'])
            }
          });
          this.disableInsuranceRadios = false;
        } else {
          this.toastr.error(data['result']['message'], "Error");
          if (data["result"]["status"] == 930 || data["result"]["status"] == 931) {
            this.openErrorDialog();
          }
        }
      },
      error: err => {
        this.toastr.error(err, "Error")
      }
    })
    this.disableInsuranceRadios = false;
  }
  isLoading;
  showAddCardForm = false;
  isShowCardFront;
  isPaypalPaymentValidation = false;
  selectedCreditCardID = "";
  selectedCreditCard;
  userCreditCardData;
  userCreditCardDataArray = [];
  paymentMethod = 'stripe';
  payPalErrorMessage;
  public payPalConfigTwo: IPayPalConfig;
  // Stripe Config
  stripeClientSecret;
  stripeHostName;
  // Stripe Config
  public payPalConfig?: IPayPalConfig;

  price = [];
  declaredValue;
  radarSession = "";
  cardVerifyForm = new FormGroup({
    otpInput1: new FormControl('', [Validators.required, Validators.maxLength(1)]),
    otpInput2: new FormControl('', [Validators.required, Validators.maxLength(1)]),
    otpInput3: new FormControl('', [Validators.required, Validators.maxLength(1)]),
    otpInput4: new FormControl('', [Validators.required, Validators.maxLength(1)])
  })
  creditCardForm = new FormGroup({
    nameOnCard: new FormControl('', Validators.required),
    cardNumber: new FormControl('', [Validators.required, Validators.minLength(15), Validators.pattern('^[0-9 ]*')]),
    validThruMonth: new FormControl('01', Validators.required),
    validThruYear: new FormControl('2024', Validators.required),
    securityCode: new FormControl('', [Validators.required]),
  })
  scrollintoview(element, paymentMethodFixer = false) {
    let el = window.document.getElementById(element);
    if (paymentMethodFixer == true) {
      window.document.getElementById("addCardSectionButton").click();
      el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
    }
    else {

      const elementRect = el.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - (window.innerHeight / 2);
      window.scrollTo(0, middle);
    }

  }
  showAddCardModal() {
    return document.getElementById("hiddenAddCardModalOpener").click();
  }
  changeCardFlip(flipType) {
    if (flipType == 'back') {
      this.isShowCardFront = false;

    }
    else if (flipType == 'front') {
      this.isShowCardFront = true;

    }
  }
  checkInputValidations() {
    var hasError = false

    if (this.creditCardForm.controls.nameOnCard.status == "INVALID") {
      this.creditCardForm.controls.nameOnCard.markAsTouched()
      hasError = true;
    }

    if (this.creditCardForm.controls.cardNumber.status == "INVALID") {
      this.creditCardForm.controls.cardNumber.markAsTouched()
      hasError = true;
    }

    if (this.creditCardForm.controls.validThruMonth.status == "INVALID") {
      this.creditCardForm.controls.validThruMonth.markAsTouched()
      hasError = true;
    }

    if (this.creditCardForm.controls.validThruYear.status == "INVALID") {
      this.creditCardForm.controls.validThruYear.markAsTouched()
      hasError = true;
    }

    if (this.creditCardForm.controls.securityCode.status == "INVALID") {
      this.creditCardForm.controls.securityCode.markAsTouched()
      hasError = true;
    }



    return hasError;


  }
  checkInputValidationsVerify() {
    var hasError = false

    if (this.cardVerifyForm.controls.otpInput1.status == "INVALID") {
      this.cardVerifyForm.controls.otpInput1.markAsTouched()
      hasError = true;
    }
    if (this.cardVerifyForm.controls.otpInput2.status == "INVALID") {
      this.cardVerifyForm.controls.otpInput2.markAsTouched()
      hasError = true;
    }
    if (this.cardVerifyForm.controls.otpInput3.status == "INVALID") {
      this.cardVerifyForm.controls.otpInput3.markAsTouched()
      hasError = true;
    }
    if (this.cardVerifyForm.controls.otpInput4.status == "INVALID") {
      this.cardVerifyForm.controls.otpInput4.markAsTouched()
      hasError = true;
    }

    return hasError;

  }
  addNewCard() {
    // Session Check, If fails Interceptor will redirect 
    this.signUpService.getUserByUserID(this.userID, this.token).subscribe()
    if (this.checkInputValidations() == false) {
      this.isLoading = true;
      var userData = {
        cc: {
          card_number: this.creditCardForm.value.cardNumber,
          cvc: this.creditCardForm.value.securityCode,
          exp_month: this.creditCardForm.value.validThruMonth,
          exp_year: this.creditCardForm.value.validThruYear,
          name: this.creditCardForm.value.nameOnCard
        }
      }
      this.signUpService.AddCreditCard(this.token, userData).subscribe(data => {
        if (data["result"]["status"] == 200) {
          this.toastr.success(data["result"]["message"], 'Success');
          this.userCreditCardData = data["data"];
          this.userCreditCardDataArray = this.userCreditCardData.filter(creditCard => {
            return creditCard.list_card == 1 && creditCard.status > 0;
          });
          this.showAddCardForm = false;
          this.creditCardForm.reset({
            validThruMonth: '06',
            validThruYear: '2022'
          });
          if (this.userCreditCardDataArray.length > 1) {
            const lastAddedCreditCard = this.userCreditCardDataArray.reduce(
              function (prev, current) {
                return (prev.date > current.date) ? prev : current;
              }
            )
            this.selectedCreditCard = lastAddedCreditCard;
            this.selectedCreditCardID = lastAddedCreditCard.id
          } else if (this.userCreditCardDataArray.length == 1) {
            const lastAddedCreditCard = this.userCreditCardDataArray[0];
            if (lastAddedCreditCard) {
              this.selectedCreditCard = lastAddedCreditCard;
              this.selectedCreditCardID = lastAddedCreditCard.id;
            }
            this.isLoading = false;

          } else {
            this.isLoading = false;
          }
          this.isLoading = false;
          this.paymentMethod = 'credit_card';
          this.scrollintoview('credit-card-box');

        }
        else {
          if (data["result"]["message"] == "Your card was declined. This transaction requires authentication.") {
            this.toastr.warning("This card requires authentication. Please Pay With 3D Secure ", 'Warning', { timeOut: 10000 });
            this.showAddCardForm = false;
            this.paymentMethod = 'stripe';
            this.scrollintoview('stripe-box');
            this.isLoading = false;
          }
          else {
            this.toastr.error(data["result"]["message"], 'Error');
            this.isLoading = false;
          }
        }
        this.isLoading = false;
      })
    }
  }
  deleteCreditCard(creditCard) {
    var userData = {
      card_id: creditCard.id
    }
    this.signUpService.deleteCreditCard(this.token, userData).subscribe(data => {
      if (data["result"]["status"] == 200) {
        this.toastr.success(data["result"]["message"], 'Success');
        //location.reload()
        this.userCreditCardData = data["data"];
        this.userCreditCardDataArray = data["data"];
        this.paymentMethod = 'stripe'
      }
      else {
        this.toastr.error(data["result"]["message"], 'Error');
      }
    })
  }
  startCardVerifyStatusZero(creditCard) {
    var userData = {
      stripe_customer_id: creditCard.customer
    }
    this.signUpService.verifyCreditCardWithHasError(this.token, userData).subscribe(data => {
      if (data["result"]["status"] == 200) {
        this.toastr.success(data["result"]["message"], 'Success');
      }
      else {
        this.toastr.error(data["result"]["message"], 'Error');
      }
    })
  }
  startCardVerifyStatusOne(creditCard) {
    if (this.checkInputValidationsVerify() == false) {
      this.isLoading = true;
      let userData = {
        client_amount: `${this.cardVerifyForm.value.otpInput1}${this.cardVerifyForm.value.otpInput2}${this.cardVerifyForm.value.otpInput3}${this.cardVerifyForm.value.otpInput4}`,
        id: creditCard.id
      }
      this.signUpService.verifyCreditCardWithStatusOne(this.token, userData).subscribe(data => {
        if (data["result"]["status"] == 200) {
          this.toastr.success(data["result"]["message"], 'Success');
          //location.reload()
          this.userCreditCardData = data["data"];
          this.userCreditCardDataArray = this.userCreditCardData.filter(creditCard => {
            return creditCard.status == 3;
          });
          this.cardVerifyForm.reset({});
          const lastConfirmedCreditCard = this.userCreditCardDataArray.reduce(
            function (prev, current) {
              return (prev.date > current.date) ? prev : current;
            }
          )
          // Kart doğrulama başarılı, şimdi seçili yap. 
          // selectedCreditCard' a son eklenen kartın idsini pasla.
          this.selectedCreditCard = lastConfirmedCreditCard;
          this.selectedCreditCardID = lastConfirmedCreditCard.id;
          this.paymentMethod = 'credit_card';
        }
        else {
          this.toastr.error(data["result"]["message"], 'Error');
          this.cardVerifyForm.reset({
          })
          this.toastr.error(data["result"]["message"], 'Error');
          this.signUpService.getUserCreditCards(this.token).subscribe({
            next: data => {
              if (data["result"]["status"] != 200) {
                this.toastr.error('Error', data["result"]["message"]);
              }
              else {
                this.userCreditCardData = data["data"];
                if (this.userCreditCardData?.length > 0) {
                  // Listed Cards 
                  this.userCreditCardDataArray = this.userCreditCardData.filter(creditCard => {
                    return creditCard.list_card == 1 && creditCard.status > 0 && !creditCard.wallet;
                  });
                  // Verified Cards
                  const verifiedCreditCard = this.userCreditCardDataArray.filter(creditCard => {
                    return creditCard.status == 3;
                  });
                  const unVerifiedCreditCard = this.userCreditCardDataArray.filter(creditCard => {
                    return creditCard.status == 1 || (creditCard.status == 2 && creditCard.verification_attempts < 2);
                  });

                  const verified3dSecureCreditCard = this.userCreditCardDataArray.filter(creditCard => {
                    return creditCard.payment_method_id != "";
                  });
                  if (verified3dSecureCreditCard.length > 0) {
                    const lastVerifiedCreditCard = verified3dSecureCreditCard.reduce(
                      function (prev, current) {
                        return (prev.date > current.date) ? prev : current;
                      }
                    )
                    this.selectedCreditCard = lastVerifiedCreditCard;
                    this.selectedCreditCardID = lastVerifiedCreditCard.id;
                    this.paymentMethod = 'credit_card';
                  }
                  if (verified3dSecureCreditCard.length < 1 && verifiedCreditCard.length > 0) {
                    const lastVerifiedCreditCard = verifiedCreditCard.reduce(
                      function (prev, current) {
                        return (prev.date > current.date) ? prev : current;
                      }
                    )
                    this.selectedCreditCard = lastVerifiedCreditCard;
                    this.selectedCreditCardID = lastVerifiedCreditCard.id;
                    this.paymentMethod = 'credit_card';
                  }

                  if (verified3dSecureCreditCard.length < 1 && verifiedCreditCard.length < 1 && unVerifiedCreditCard.length > 0) {
                    this.showAddCardForm = false;
                    const lastunVerifiedCreditCard = unVerifiedCreditCard.reduce(
                      function (prev, current) {
                        return (prev.date > current.date) ? prev : current;
                      }
                    )
                    this.selectedCreditCard = lastunVerifiedCreditCard;
                    this.selectedCreditCardID = lastunVerifiedCreditCard.id;
                    this.paymentMethod = 'credit_card';
                  }
                } else {
                  this.paymentMethod = 'stripe';
                  this.showAddCardForm = false;
                }

              }
            }
          })
        }
        this.isLoading = false
      })
    } else {
      this.toastr.error("Verify Form Has Error");
      this.cardVerifyForm.reset({
        otpInput1: '',
        otpInput2: '',
        otpInput3: '',
        otpInput4: ''
      })
    }
  }
  onKeyPresOTP(event, index) {
    let input1 = document.getElementById('otpInput1') as HTMLInputElement;
    let input2 = document.getElementById('otpInput2') as HTMLInputElement;
    let input3 = document.getElementById('otpInput3') as HTMLInputElement;
    let input4 = document.getElementById('otpInput4') as HTMLInputElement;

    if (event.key == 'Backspace') {
      switch (index) {
        case 1:
          this.cardVerifyForm.controls.otpInput1.setValue('')
          input1.focus()
          break;
        case 2:
          this.cardVerifyForm.controls.otpInput2.setValue('')
          input1.focus()
          break;
        case 3:
          this.cardVerifyForm.controls.otpInput3.setValue('')
          input2.focus()
          break;
        case 4:
          this.cardVerifyForm.controls.otpInput4.setValue('')
          input3.focus();
          break;
        default:
          break;
      }
    } else if (event.which < 48 || event.which > 90) {
      return;
    } else {
      switch (index) {
        case 1:
          if (!event.code.includes('Digit')) {
            this.cardVerifyForm.controls.otpInput1.setValue('')
          } else {
            this.cardVerifyForm.controls.otpInput1.setValue(event.key)
            this.cardVerifyForm.controls.otpInput1.value ? input2.focus() : input1.focus()
          }

          break;
        case 2:
          if (!event.code.includes('Digit')) {
            this.cardVerifyForm.controls.otpInput2.setValue('')
          } else {
            this.cardVerifyForm.controls.otpInput2.setValue(event.key)
            this.cardVerifyForm.controls.otpInput2.value ? input3.focus() : input2.focus()
          }
          break;
        case 3:
          if (!event.code.includes('Digit')) {
            this.cardVerifyForm.controls.otpInput3.setValue('')
          } else {
            this.cardVerifyForm.controls.otpInput3.setValue(event.key)
            this.cardVerifyForm.controls.otpInput3.value ? input4.focus() : input3.focus()
          }
          break;
        case 4:
          if (!event.code.includes('Digit')) {
            this.cardVerifyForm.controls.otpInput4.setValue('')
          } else {
            this.cardVerifyForm.controls.otpInput4.setValue(event.key)
            this.cardVerifyForm.controls.otpInput4.value ? input4.blur() : input4.focus()
          }
          break;
        default:
          break;
      }
    }
  }
  confirmOrder() {
    this.isLoading = true;
    if (this.selectedCreditCard.payment_method_id) {
      var saved3dCardPayload = {
        company_id: this.selectedShipment.company_id,
        payment_with_paypal: 0,
        paypal: "",
        promo_code: "",
        service_type: this.selectedShipment.service_type,
        vendor: this.selectedShipment.vendor,
        payment_with_stripe3ds: 1,
        payment_method_id: this.selectedCreditCard?.payment_method_id,
        customer: this.selectedCreditCard?.customer,
        b2b_shipment_number: this.b2b_shipment.shipment_number,
        b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
        shopper_email: this.form.value.emailAddress,
        b2b_user_email: this.memberDetails.email,
        from_address_id: this.customSenderInfo['id'],
        to_address: {
          name: this.form.value.recipient,
          street1: this.form.value.addressLineOne,
          street2: this.form.value.addressLineTwo,
          city: this.form.value.cityName,
          state: this.form.value.state,
          zip: this.form.value.postCode,
          country: this.form.value.country,
          phone: this.form.value.phoneNumber,
          email: this.form.value.emailAddress,
          company: this.form.value.companyName,
        },
        from_address: {
          name: this.customSenderInfo.senderName,
          street1: this.customSenderInfo.addressLineOne,
          street2: this.customSenderInfo.addressLineTwo,
          city: this.customSenderInfo.cityName,
          state: this.customSenderInfo.state,
          zip: this.customSenderInfo.postCode,
          country: this.customSenderInfo.country,
          phone: this.customSenderInfo.senderPhone,
          email: this.customSenderInfo.senderEmail
        },
        parcel: {
          length: this.parcelAndLabelOptionsForm.value.length,
          width: this.parcelAndLabelOptionsForm.value.width,
          height: this.parcelAndLabelOptionsForm.value.height,
          weight: this.parcelAndLabelOptionsForm.value.weight,
          weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
          dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
        },
        customs_info: {
          customs_items: this.customsForm.value.customsItems
        },
        options: {
          eel_pfc: this.customsForm.value.eelOrPfcNumber,
          restriction_type: this.customsForm.value.restrictionType,
          contents_type: this.customsForm.value.contentType,
          contents_explanation: this.customsForm.value.explanationOfContent,
          label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
          invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
        },
        insurance: parseInt(this.insuranceSelected),
        insurance_exists: parseInt(this.insuranceSelected),
      }
      this.signUpService.confirmB2BOrder(this.token, saved3dCardPayload).pipe(
        switchMap((data) => {
          if (data["result"]["status"] == 200) {
            const stripe = Stripe(this.stripeClientSecret);
            return stripe.confirmCardPayment(data['data']['client_secret'], {
              payment_method: this.selectedCreditCard?.payment_method_id,
            }).then(function (result) {
              if (result.error) {
                return result;
              } else {
                if (result.paymentIntent.status === 'succeeded') {
                  return data;
                }
              }
            });
          } else {
            this.isLoading = false;
            this.toastr.error(data["result"]["message"], 'Error');
          }
        }),
        catchError(err => {
          this.isLoading = false;
          if (err.error.result.message) {
            this.toastr.error(err.error.result.message, 'Error');
          }
          return err;

        })
      ).subscribe(async data => {
        if (data['error']) {
          let errorMessage = data['error']['payment_intent']['last_payment_error']['message']
          if (errorMessage == "The latest payment attempt of this PaymentIntent has failed or been canceled, and the attached payment method has been removed. You can try confirming again with a new payment method.") {
            errorMessage = "Payment has failed or been canceled. You can try confirming again with a new payment method."
          } else if (errorMessage == "The provided PaymentMethod has failed authentication. You can provide payment_method_data or a new PaymentMethod to attempt to fulfill this PaymentIntent again.") {
            errorMessage = "Payment has failed authentication. You can try confirming again with a new payment method."
          }
          this.isLoading = false;
          this.toastr.error(data['error']['payment_intent']['last_payment_error']['message'], 'Error');
        } else {
          var confirmOrderVia3dCardPayload = {
            company_id: this.selectedShipment.company_id,
            payment_with_paypal: 0,
            paypal: "",
            promo_code: "",
            service_type: this.selectedShipment.service_type,
            vendor: this.selectedShipment.vendor,
            payment_with_stripe3ds: 1,
            payment_method_id: this.selectedCreditCard?.payment_method_id,
            payment_intent: data['data']['id'],
            customer: this.selectedCreditCard?.customer,
            b2b_shipment_number: this.b2b_shipment.shipment_number,
            b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
            shopper_email: this.form.value.emailAddress,
            b2b_user_email: this.memberDetails.email,
            from_address_id: this.customSenderInfo['id'],
            to_address: {
              name: this.form.value.recipient,
              street1: this.form.value.addressLineOne,
              street2: this.form.value.addressLineTwo,
              city: this.form.value.cityName,
              state: this.form.value.state,
              zip: this.form.value.postCode,
              country: this.form.value.country,
              phone: this.form.value.phoneNumber,
              email: this.form.value.emailAddress,
              company: this.form.value.companyName,
            },
            from_address: {
              name: this.customSenderInfo.senderName,
              street1: this.customSenderInfo.addressLineOne,
              street2: this.customSenderInfo.addressLineTwo,
              city: this.customSenderInfo.cityName,
              state: this.customSenderInfo.state,
              zip: this.customSenderInfo.postCode,
              country: this.customSenderInfo.country,
              phone: this.customSenderInfo.senderPhone,
              email: this.customSenderInfo.senderEmail
            },
            parcel: {
              length: this.parcelAndLabelOptionsForm.value.length,
              width: this.parcelAndLabelOptionsForm.value.width,
              height: this.parcelAndLabelOptionsForm.value.height,
              weight: this.parcelAndLabelOptionsForm.value.weight,
              weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
              dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
            },
            customs_info: {
              customs_items: this.customsForm.value.customsItems
            },
            options: {
              eel_pfc: this.customsForm.value.eelOrPfcNumber,
              restriction_type: this.customsForm.value.restrictionType,
              contents_type: this.customsForm.value.contentType,
              contents_explanation: this.customsForm.value.explanationOfContent,
              label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
              invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
            },
            insurance: parseInt(this.insuranceSelected),
            insurance_exists: parseInt(this.insuranceSelected),
          }
          this.signUpService.confirmB2BOrder(this.token, confirmOrderVia3dCardPayload).subscribe({
            next:
              async (data) => {
                if (data["result"]["status"] == 200) {
                  this.paymentDone = true;
                  this.signUpService.getB2BShipmentDetailViaID(this.token, this.b2b_shipment.id).subscribe({
                    next: (getShipmentRes) => {
                      this.paymentCompletedShipment = getShipmentRes['data'];
                      this.currentStep = 4;
                      this.sendGTMSuccessEvent(getShipmentRes['data']);
                      this.checkUserMoveCap();
                      this.shipment_awb_no = getShipmentRes['data']['awb_no'];
                      window.scrollTo(0, 0);
                    }
                  })
                  this.toastr.success(data["result"]["message"], 'Success');
                }
                else {
                  this.toastr.error(data["result"]["message"], 'Error');
                  this.isLoading = false;
                  if (data["result"]["status"] == 930 || data["result"]["status"] == 931) {
                    this.openErrorDialog();

                  }
                }
              },
            error: err => {
              this.isLoading = false;
              if (err.error.result.status === 930 || err.error.result.status === 931) {
                this.openErrorDialog();
              }
              this.toastr.error(err, 'Error');
            }
          })
        }
      })
    } else {
      this.isLoading = true;
      var saved2dCardPayload = {
        cc: {
          card_number: "",
          cvc: "",
          exp_month: "",
          exp_year: "",
          name: ""
        },
        cc_id: this.selectedCreditCardID,
        radar_session: this.radarSession,
        company_id: this.selectedShipment.company_id,
        payment_with_paypal: 0,
        paypal: "",
        promo_code: "",
        service_type: this.selectedShipment.service_type,
        vendor: this.selectedShipment.vendor,
        payment_with_stripe3ds: 0,
        payment_method_id: this.selectedCreditCard?.payment_method_id,
        customer: this.selectedCreditCard?.customer,
        b2b_shipment_number: this.b2b_shipment.shipment_number,
        b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
        shopper_email: this.form.value.emailAddress,
        b2b_user_email: this.memberDetails.email,
        from_address_id: this.customSenderInfo['id'],
        to_address: {
          name: this.form.value.recipient,
          street1: this.form.value.addressLineOne,
          street2: this.form.value.addressLineTwo,
          city: this.form.value.cityName,
          state: this.form.value.state,
          zip: this.form.value.postCode,
          country: this.form.value.country,
          phone: this.form.value.phoneNumber,
          email: this.form.value.emailAddress,
          company: this.form.value.companyName,
        },
        from_address: {
          name: this.customSenderInfo.senderName,
          street1: this.customSenderInfo.addressLineOne,
          street2: this.customSenderInfo.addressLineTwo,
          city: this.customSenderInfo.cityName,
          state: this.customSenderInfo.state,
          zip: this.customSenderInfo.postCode,
          country: this.customSenderInfo.country,
          phone: this.customSenderInfo.senderPhone,
          email: this.customSenderInfo.senderEmail
        },
        parcel: {
          length: this.parcelAndLabelOptionsForm.value.length,
          width: this.parcelAndLabelOptionsForm.value.width,
          height: this.parcelAndLabelOptionsForm.value.height,
          weight: this.parcelAndLabelOptionsForm.value.weight,
          weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
          dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
        },
        customs_info: {
          customs_items: this.customsForm.value.customsItems
        },
        options: {
          eel_pfc: this.customsForm.value.eelOrPfcNumber,
          restriction_type: this.customsForm.value.restrictionType,
          contents_type: this.customsForm.value.contentType,
          contents_explanation: this.customsForm.value.explanationOfContent,
          label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
          invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
        },
        insurance: parseInt(this.insuranceSelected),
        insurance_exists: parseInt(this.insuranceSelected),
      }
      this.signUpService.confirmB2BOrder(this.token, saved2dCardPayload).subscribe(data2d => {
        if (data2d["result"]["status"] == 200) {
          this.signUpService.getB2BShipmentDetailViaID(this.token, this.b2b_shipment.id).subscribe({
            next: (getShipmentRes) => {
              if (getShipmentRes['result']['status'] == 200) {
                this.paymentDone = true;
                this.isLoading = false;
                this.paymentCompletedShipment = getShipmentRes['data'];
                this.currentStep = 4;
                this.sendGTMSuccessEvent(getShipmentRes['data']);
                this.checkUserMoveCap();
                this.shipment_awb_no = getShipmentRes['data']['awb_no'];
                window.scrollTo(0, 0);
              } else {
                this.toastr.error(getShipmentRes['data']['result']['message'], 'Error');
              }
            }
          })
          this.toastr.success(data2d["result"]["message"], 'Success');
        }
        else {
          this.toastr.error(data2d["result"]["message"], 'Error');
          this.isLoading = false;
          if (data2d["result"]["status"] == 930 || data2d["result"]["status"] == 931) {
            this.openErrorDialog();
          }
        }
      })
    }
  }
  showSuccess;
  showCancel;
  showError;
  errorMessagePaypal;
  private initConfigForVerified(): void {
    this.payPalConfig = {
      currency: 'USD',
      clientId: this.signUpService.paypalClientID,
      createOrderOnServer: (data) => {
        this.signUpService.getUserByUserID(this.userID, this.token).subscribe();
        var payload;
        if (this.selectedShipment.shipment_id && this.selectedShipment.shipment_id.includes('-')) {
          payload = {
            company_id: this.selectedShipment.company_id,
            payment_with_paypal: 1,
            paypal: "",
            promo_code: "",
            service_type: this.selectedShipment.service_type,
            vendor: this.selectedShipment.vendor,
            payment_with_stripe3ds: 0,
            b2b_shipment_number: this.b2b_shipment.shipment_number,
            b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
            cc: {
              card_number: "",
              cvc: "",
              exp_month: "",
              exp_year: "",
              name: ""
            },
            cc_id: this.selectedCreditCardID,
            shopper_email: this.form.value.emailAddress,
            b2b_user_email: this.memberDetails.email,
            from_address_id: this.customSenderInfo['id'],
            to_address: {
              name: this.form.value.recipient,
              street1: this.form.value.addressLineOne,
              street2: this.form.value.addressLineTwo,
              city: this.form.value.cityName,
              state: this.form.value.state,
              zip: this.form.value.postCode,
              country: this.form.value.country,
              phone: this.form.value.phoneNumber,
              email: this.form.value.emailAddress,
              company: this.form.value.companyName,
            },
            from_address: {
              name: this.customSenderInfo.senderName,
              street1: this.customSenderInfo.addressLineOne,
              street2: this.customSenderInfo.addressLineTwo,
              city: this.customSenderInfo.cityName,
              state: this.customSenderInfo.state,
              zip: this.customSenderInfo.postCode,
              country: this.customSenderInfo.country,
              phone: this.customSenderInfo.senderPhone,
              email: this.customSenderInfo.senderEmail
            },
            parcel: {
              length: this.parcelAndLabelOptionsForm.value.length,
              width: this.parcelAndLabelOptionsForm.value.width,
              height: this.parcelAndLabelOptionsForm.value.height,
              weight: this.parcelAndLabelOptionsForm.value.weight,
              weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
              dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
            },
            customs_info: {
              customs_items: this.customsForm.value.customsItems
            },
            options: {
              eel_pfc: this.customsForm.value.eelOrPfcNumber,
              restriction_type: this.customsForm.value.restrictionType,
              contents_type: this.customsForm.value.contentType,
              contents_explanation: this.customsForm.value.explanationOfContent,
              label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
              invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
            },
            insurance: parseInt(this.insuranceSelected),
            insurance_exists: parseInt(this.insuranceSelected),
          }
        } else {
          payload = {
            company_id: this.selectedShipment.company_id,
            payment_with_paypal: 1,
            paypal: "",
            promo_code: "",
            service_type: this.selectedShipment.service_type,
            vendor: this.selectedShipment.vendor,
            payment_with_stripe3ds: 0,
            b2b_shipment_number: this.b2b_shipment.shipment_number,
            b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
            cc: {
              card_number: "",
              cvc: "",
              exp_month: "",
              exp_year: "",
              name: ""
            },
            cc_id: this.selectedCreditCardID,
            shopper_email: this.form.value.emailAddress,
            b2b_user_email: this.memberDetails.email,
            from_address_id: this.customSenderInfo['id'],
            to_address: {
              name: this.form.value.recipient,
              street1: this.form.value.addressLineOne,
              street2: this.form.value.addressLineTwo,
              city: this.form.value.cityName,
              state: this.form.value.state,
              zip: this.form.value.postCode,
              country: this.form.value.country,
              phone: this.form.value.phoneNumber,
              email: this.form.value.emailAddress,
              company: this.form.value.companyName,
            },
            from_address: {
              name: this.customSenderInfo.senderName,
              street1: this.customSenderInfo.addressLineOne,
              street2: this.customSenderInfo.addressLineTwo,
              city: this.customSenderInfo.cityName,
              state: this.customSenderInfo.state,
              zip: this.customSenderInfo.postCode,
              country: this.customSenderInfo.country,
              phone: this.customSenderInfo.senderPhone,
              email: this.customSenderInfo.senderEmail
            },
            parcel: {
              length: this.parcelAndLabelOptionsForm.value.length,
              width: this.parcelAndLabelOptionsForm.value.width,
              height: this.parcelAndLabelOptionsForm.value.height,
              weight: this.parcelAndLabelOptionsForm.value.weight,
              weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
              dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
            },
            customs_info: {
              customs_items: this.customsForm.value.customsItems
            },
            options: {
              eel_pfc: this.customsForm.value.eelOrPfcNumber,
              restriction_type: this.customsForm.value.restrictionType,
              contents_type: this.customsForm.value.contentType,
              contents_explanation: this.customsForm.value.explanationOfContent,
              label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
              invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
            },
            insurance: parseInt(this.insuranceSelected),
            insurance_exists: parseInt(this.insuranceSelected),
          }
        }
        return this.signUpService.confirmB2BOrder(this.token, payload).toPromise().then(
          res => {
            return res['data']['paypal_order_id'].toString()
          }
        )
      },
      advanced: {
        commit: 'true',
        extraQueryParams: [{ name: "disable-funding", value: "credit,card" }]
      },
      style: {
        label: 'paypal',
        layout: 'vertical',
        height: 42
      },
      onApprove: (data, actions) => {
        var approvePayload;
        if (this.selectedShipment.shipment_id && this.selectedShipment.shipment_id.includes('-')) {
          approvePayload = {
            paymentID: data.orderID,
            payerID: data.payerID,
            company_id: this.selectedShipment.company_id,
            payment_with_paypal: 1,
            paypal: "",
            promo_code: "",
            service_type: this.selectedShipment.service_type,
            vendor: this.selectedShipment.vendor,
            payment_with_stripe3ds: 0,
            b2b_shipment_number: this.b2b_shipment.shipment_number,
            b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
            cc: {
              card_number: "",
              cvc: "",
              exp_month: "",
              exp_year: "",
              name: ""
            },
            cc_id: this.selectedCreditCardID,
            shopper_email: this.form.value.emailAddress,
            b2b_user_email: this.memberDetails.email,
            from_address_id: this.customSenderInfo['id'],
            to_address: {
              name: this.form.value.recipient,
              street1: this.form.value.addressLineOne,
              street2: this.form.value.addressLineTwo,
              city: this.form.value.cityName,
              state: this.form.value.state,
              zip: this.form.value.postCode,
              country: this.form.value.country,
              phone: this.form.value.phoneNumber,
              email: this.form.value.emailAddress,
              company: this.form.value.companyName,
            },
            from_address: {
              name: this.customSenderInfo.senderName,
              street1: this.customSenderInfo.addressLineOne,
              street2: this.customSenderInfo.addressLineTwo,
              city: this.customSenderInfo.cityName,
              state: this.customSenderInfo.state,
              zip: this.customSenderInfo.postCode,
              country: this.customSenderInfo.country,
              phone: this.customSenderInfo.senderPhone,
              email: this.customSenderInfo.senderEmail
            },
            parcel: {
              length: this.parcelAndLabelOptionsForm.value.length,
              width: this.parcelAndLabelOptionsForm.value.width,
              height: this.parcelAndLabelOptionsForm.value.height,
              weight: this.parcelAndLabelOptionsForm.value.weight,
              weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
              dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
            },
            customs_info: {
              customs_items: this.customsForm.value.customsItems
            },
            options: {
              eel_pfc: this.customsForm.value.eelOrPfcNumber,
              restriction_type: this.customsForm.value.restrictionType,
              contents_type: this.customsForm.value.contentType,
              contents_explanation: this.customsForm.value.explanationOfContent,
              label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
              invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
            },
            insurance: parseInt(this.insuranceSelected),
            insurance_exists: parseInt(this.insuranceSelected),
          }
        } else {
          approvePayload = {
            paymentID: data.orderID,
            payerID: data.payerID,
            company_id: this.selectedShipment.company_id,
            payment_with_paypal: 1,
            paypal: "",
            promo_code: "",
            service_type: this.selectedShipment.service_type,
            vendor: this.selectedShipment.vendor,
            payment_with_stripe3ds: 0,
            b2b_shipment_number: this.b2b_shipment.shipment_number,
            b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
            cc: {
              card_number: "",
              cvc: "",
              exp_month: "",
              exp_year: "",
              name: ""
            },
            cc_id: this.selectedCreditCardID,
            shopper_email: this.form.value.emailAddress,
            b2b_user_email: this.memberDetails.email,
            from_address_id: this.customSenderInfo['id'],
            to_address: {
              name: this.form.value.recipient,
              street1: this.form.value.addressLineOne,
              street2: this.form.value.addressLineTwo,
              city: this.form.value.cityName,
              state: this.form.value.state,
              zip: this.form.value.postCode,
              country: this.form.value.country,
              phone: this.form.value.phoneNumber,
              email: this.form.value.emailAddress,
              company: this.form.value.companyName,
            },
            from_address: {
              name: this.customSenderInfo.senderName,
              street1: this.customSenderInfo.addressLineOne,
              street2: this.customSenderInfo.addressLineTwo,
              city: this.customSenderInfo.cityName,
              state: this.customSenderInfo.state,
              zip: this.customSenderInfo.postCode,
              country: this.customSenderInfo.country,
              phone: this.customSenderInfo.senderPhone,
              email: this.customSenderInfo.senderEmail
            },
            parcel: {
              length: this.parcelAndLabelOptionsForm.value.length,
              width: this.parcelAndLabelOptionsForm.value.width,
              height: this.parcelAndLabelOptionsForm.value.height,
              weight: this.parcelAndLabelOptionsForm.value.weight,
              weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
              dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
            },
            customs_info: {
              customs_items: this.customsForm.value.customsItems
            },
            options: {
              eel_pfc: this.customsForm.value.eelOrPfcNumber,
              restriction_type: this.customsForm.value.restrictionType,
              contents_type: this.customsForm.value.contentType,
              contents_explanation: this.customsForm.value.explanationOfContent,
              label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
              invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
            },
            insurance: parseInt(this.insuranceSelected),
            insurance_exists: parseInt(this.insuranceSelected),
          }
        }
        this.signUpService.confirmB2BOrder(this.token, approvePayload).subscribe(data => {
          if (data["result"]["status"] == 200) {
            this.signUpService.getB2BShipmentDetailViaID(this.token, this.b2b_shipment.id).subscribe({
              next: (getShipmentRes) => {
                if (getShipmentRes['result']['status'] === 200) {
                  this.paymentDone = true;
                  this.paymentCompletedShipment = getShipmentRes['data'];
                  this.currentStep = 4;
                  this.checkUserMoveCap();
                  this.sendGTMSuccessEvent(getShipmentRes['data']);
                  this.shipment_awb_no = getShipmentRes['data']['awb_no'];
                  window.scrollTo(0, 0);
                } else {
                  this.toastr.error(getShipmentRes['result']['message'], "Error")
                }
              }
            })
            this.toastr.success(data["result"]["message"], 'Success');
          }
          else {
            this.toastr.error(data["result"]["message"], 'Error');
            this.isLoading = false;
            if (data["result"]["status"] == 930 || data["result"]["status"] == 931) {
              this.openErrorDialog();
            }
          }
        })
        actions.order.get().then(details => {
        });
      },
      onCancel: (data, actions) => {
        this.showCancel = true;
      },
      onError: err => {
        this.showError = true;
      },
    };
  }
  addNewPaypal(response) {
    document.getElementById("payPalVerificationModalButton").click();
    this.isLoading = true;
    var userData = {
      paypal: response
    }

    this.signUpService.verificationPaypal(this.token, userData).subscribe(data => {
      if (data["result"]["status"] == 200) {
        if (data["data"].payer.status == "VERIFIED" || data["data"].payer.status == "Non-US Verified") {
          this.isPaypalPaymentValidation = true;
          this.toastr.success('Your PayPal account has been verified', 'Success');
          document.getElementById('paypalVerificationModalCloser').click();
          this.errorMessagePaypal = "";
          this.isLoading = false;
          this.initConfigForVerified();
        } else {
          this.toastr.error('Your Paypal account is not verified. Please use a different payment method.', 'Error');
          this.errorMessagePaypal = "Your Paypal account is not verified. Please use a different payment method."
          this.isLoading = false;
        }
        this.isLoading = false;
      }

      else if (data["result"]["status"] == 900 || data["result"]["status"] == 901) {

        this.toastr.error("Error", 'Error');
        this.payPalErrorMessage = data["result"]["message"];
        this.isLoading = false;
      }
      else {
        this.errorMessagePaypal = data["result"]["message"] + " Please use a different payment method";
        this.toastr.error(data["result"]["message"] + " Please use a different payment method", 'Error');
        this.isLoading = false;
      }
    })
  }
  private initConfigForUnverified(): void {
    this.payPalConfigTwo = {
      currency: 'USD',
      clientId: this.signUpService.paypalClientID,
      createOrderOnClient: (data) => <ICreateOrderRequest>{
        intent: 'CAPTURE',
        purchase_units: [{
          amount: {
            currency_code: 'USD',
            value: "0.50",
            breakdown: {
              item_total: {
                currency_code: 'USD',
                value: "0.50"
              }
            }
          },
          description: this.memberDetails.id.toString()
        }]
      },
      advanced: {
        commit: 'true',
        extraQueryParams: [{ name: "disable-funding", value: "credit,card" }]
      },
      style: {
        label: 'paypal',
        layout: 'vertical',
        color: 'blue',
        height: 42
      },
      onApprove: (data, actions) => {
        return actions.order.capture().then((response) => {
          this.addNewPaypal(response);
        });
      },
      onClientAuthorization: (data) => {
        //this.showSuccess = true;
      },
      onCancel: (data, actions) => {
        //this.showCancel = true;
      },
      onError: err => {
        //this.showError = true;
      },
      onClick: (data, actions) => {
      },
    };
  }
  waitingforPaypal = true;
  waitforResponse() {
    setTimeout(() => {
      this.waitingforPaypal = false;
    }, 1700);
  }
  currentPaymentIntent;

  drawStripePaymentElement() {
    let api = this.signUpService.api;
    let stripeHostName = this.signUpService.stripeHostName;
    let stripeClientSecret = this.signUpService.stripeClientSecret;
    this.stripeClientSecret = this.signUpService.stripeClientSecret;
    let stripeElementToken = this.token;
    let toastr = this.toastr;
    let orderAmountS = this.selectedShipment;
    let currentPaymentIntent = this.currentPaymentIntent;
    let selectedShipment = this.selectedShipment;
    let b2b_shipment = this.b2b_shipment;
    let memberDetails = this.memberDetails;
    let form = this.form;
    let parcelAndLabelOptionsForm = this.parcelAndLabelOptionsForm;
    let customsForm = this.customsForm;
    let customSenderInfo = this.customSenderInfo;
    let insuranceSelected = this.insuranceSelected;
    initialize();
    // Stripe 
    const stripe = Stripe(stripeClientSecret, { canCreateRadarSession: true });
    stripe.createRadarSession().then((result) => {
      this.radarSession = result.radarSession.id;
    });
    let elements;
    checkStatus();
    async function initialize() {
      const response = await fetch(`${api}shipment/b2b/pay`, {
        method: "POST",
        headers: {
          "x-access-token": stripeElementToken,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          insurance: parseInt(insuranceSelected),
          insurance_exists: parseInt(insuranceSelected),
          rate_id: selectedShipment.rate_id ? selectedShipment.rate_id : '',
          service: selectedShipment.rate_service ? selectedShipment.rate_service : '',
          shipment_id: selectedShipment.shipment_id ? selectedShipment.shipment_id : '',
          company_id: selectedShipment.company_id,
          payment_with_paypal: 0,
          paypal: "",
          promo_code: "",
          service_type: selectedShipment.service_type,
          vendor: selectedShipment.vendor,
          payment_with_stripe3ds: 1,
          payment_method_type: ["card", "klarna"],
          b2b_shipment_number: b2b_shipment.shipment_number,
          b2b_recipient_id: b2b_shipment.b2b_recipient_id,
          shopper_email: form.value.emailAddress,
          b2b_user_email: memberDetails.email,
          from_address_id: customSenderInfo['id'],
          to_address: {
            name: form.value.recipient,
            street1: form.value.addressLineOne,
            city: form.value.cityName,
            state: form.value.state,
            zip: form.value.postCode,
            country: form.value.country,
            phone: form.value.phoneNumber,
            email: form.value.emailAddress,
          },
          from_address: {
            name: customSenderInfo.senderName,
            street1: customSenderInfo.addressLineOne,
            street2: customSenderInfo.addressLineTwo ? customSenderInfo.addressLineTwo : "",
            city: customSenderInfo.cityName,
            state: customSenderInfo.state,
            zip: customSenderInfo.postCode,
            country: customSenderInfo.country,
            phone: customSenderInfo.senderPhone,
            email: customSenderInfo.senderEmail
          },
          parcel: {
            length: parcelAndLabelOptionsForm.value.length,
            width: parcelAndLabelOptionsForm.value.width,
            height: parcelAndLabelOptionsForm.value.height,
            weight: parcelAndLabelOptionsForm.value.weight,
            weight_unit: parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
            dimension_unit: parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
          },
          customs_info: {
            customs_items: customsForm.value.customsItems
          },
          options: {
            eel_pfc: customsForm.value.eelOrPfcNumber,
            restriction_type: customsForm.value.restrictionType,
            contents_type: customsForm.value.contentType,
            contents_explanation: customsForm.value.explanationOfContent,
            label_format: parcelAndLabelOptionsForm.value.labelFormat,
            invoice_number: parcelAndLabelOptionsForm.value.invoiceNumber
          }
        }),
      }).then(response => response.json()).then(data => {
        let clientSecret = data['data']['client_secret'];
        const appearance = {
          theme: 'stripe',
          variables: {
            colorPrimary: '#ff6c36',
            colorBackground: '#ffffff',
            colorText: '#222222',
            colorDanger: '#df1b41',
            fontFamily: 'Roboto, system-ui, sans-serif',
            borderRadius: '4px',
          }
        };
        elements = stripe.elements({ appearance, clientSecret });
        const paymentElement = elements.create("payment");
        paymentElement.unmount();
        paymentElement.mount("#payment-element");
        return data;
      });
      const payment_intent_id = response['id']
      if (payment_intent_id) {
        this.currentPaymentIntent = payment_intent_id;
      }

    }
    let handleSubmit = async (e) => {
      this.isLoading = true;
      this.signUpService.getUserByUserID(this.userID, this.token).subscribe()
      //this.confirmOrderViaStripeForm(elements)
      e.preventDefault();
      setLoading(true);
      const baseUrl = `${this.stripeHostName}${this.lang}/b2b/create-shipment`;
      const params = {
        payment_with_paypal: '0',
        paypal: '',
        promo_code: '',
        payment_with_stripe3ds: '1',
        payment_method_type: JSON.stringify(["card", "klarna"]),
        company_id: this.selectedShipment.company_id,
        service_type: this.selectedShipment.service_type,
        vendor: this.selectedShipment.vendor,
        b2b_shipment_number: this.b2b_shipment.shipment_number,
        b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
        b2b_shipment_id: this.b2b_shipment.id,
        shopper_email: this.form.value.emailAddress,
        b2b_user_email: this.memberDetails.email,
        from_address_id: this.customSenderInfo['id'],
        to_address: JSON.stringify({
          name: this.form.value.recipient,
          street1: this.form.value.addressLineOne,
          street2: this.form.value.addressLineTwo,
          city: this.form.value.cityName,
          state: this.form.value.state,
          zip: this.form.value.postCode,
          country: this.form.value.country,
          phone: this.form.value.phoneNumber,
          email: this.form.value.emailAddress,
          company: this.form.value.companyName,
        }),
        from_address: JSON.stringify({
          name: this.customSenderInfo.senderName,
          street1: this.customSenderInfo.addressLineOne,
          street2: this.customSenderInfo.addressLineTwo,
          city: this.customSenderInfo.cityName,
          state: this.customSenderInfo.state,
          zip: this.customSenderInfo.postCode,
          country: this.customSenderInfo.country,
          phone: this.customSenderInfo.senderPhone,
          email: this.customSenderInfo.senderEmail
        }),
        parcel: JSON.stringify({
          length: this.parcelAndLabelOptionsForm.value.length,
          width: this.parcelAndLabelOptionsForm.value.width,
          height: this.parcelAndLabelOptionsForm.value.height,
          weight: this.parcelAndLabelOptionsForm.value.weight,
          weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
          dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
        }),
        customs_info: JSON.stringify({
          customs_items: this.customsForm.value.customsItems
        }),
        options: JSON.stringify({
          eel_pfc: this.customsForm.value.eelOrPfcNumber,
          restriction_type: this.customsForm.value.restrictionType,
          contents_type: this.customsForm.value.contentType,
          contents_explanation: this.customsForm.value.explanationOfContent,
          label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
          invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
        }),
        insurance: this.insuranceSelected.toString(),
        insurance_exists: this.insuranceSelected.toString(),
      };
      const stringParams: Record<string, string> = {};
      for (const key in params) {
        stringParams[key] = String(params[key]);
      }
      const queryString = new URLSearchParams(stringParams).toString();
      const returnUrl = `${baseUrl}?${queryString}`;

      await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: returnUrl,
        },
        redirect: "if_required"
      }).then(result => {
        if (result.error) {
          if (result.error.type == "validation_error" || !result.error.payment_intent) {
            this.isLoading = false;
            setLoading(false);
            return this.toastr.error("You must complete the form!")
          };
          let errorMessage = result['error']['payment_intent']['last_payment_error']['message'];
          if (errorMessage == "The latest payment attempt of this PaymentIntent has failed or been canceled, and the attached payment method has been removed. You can try confirming again with a new payment method.") {
            errorMessage = "Payment has failed or been canceled. You can try confirming again with a new payment method."
          } else if (errorMessage == "The provided PaymentMethod has failed authentication. You can provide payment_method_data or a new PaymentMethod to attempt to fulfill this PaymentIntent again.") {
            errorMessage = "Payment has failed authentication. You can try confirming again with a new payment method."
          } else if (errorMessage == "Your card was declined.") {
            errorMessage = "Your card does not support 3DS or declined. Try to add your card for Shippn verification process from Add a credit card section."
          }
          this.isLoading = false;
          setLoading(false);
          if (result.error.payment_method.card.three_d_secure_usage.supported == false) {
            toastr.warning("3D Secure is not supported for this card. Please use a Add a Credit Card for verification.", 'Warning', { timeOut: 10000 });
            this.scrollintoview('add-card-box', true)
            this.paymentMethod = 'Add-Card';
            this.paymentMethod = 'Add-Card';
            setLoading(false);
            this.isLoading = false;
          } else {
            setLoading(false);
            this.isLoading = false;
            toastr.error(errorMessage, 'Error');
          }
          //setLoading(false);
          //this.isLoading = false;
          //this.toastr.error(errorMessage, 'Error');
          //this.stripePaymentConfirm(result.error.payment_intent.id);
        } else {
          this.stripePaymentConfirm(result.paymentIntent.id);
          // setLoading(false);
          // this.isLoading = false;
        }
      });
      //setLoading(false);
    }
    // Fetches the payment intent status after payment submission
    async function checkStatus() {
      const clientSecret = new URLSearchParams(window.location.search).get(
        "payment_intent_client_secret"
      );
      if (!clientSecret) {
        return;
      }
      const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);
      switch (paymentIntent.status) {
        case "succeeded":
          //showMessage("Payment succeeded!");
          break;
        case "processing":
          //showMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          //showMessage("Your payment was not successful, please try again.");
          break;
        default:
          //showMessage("Something went wrong.");
          break;
      }
    }
    function setLoading(isLoading) {
      if (isLoading) {
        // Disable the button and show a spinner
        (document.querySelector("#submit") as HTMLButtonElement).disabled = true;
        window.document.querySelector("#spinner").classList.remove("hidden");
        window.document.querySelector("#button-text").classList.add("hidden");
      } else {
        (document.querySelector("#submit") as HTMLButtonElement).disabled = false;
        window.document.querySelector("#spinner").classList.add("hidden");
        window.document.querySelector("#button-text").classList.remove("hidden");
      }
    }
    var el = document.getElementById("submit");
    if (el) {
      document.querySelector("#payment-form").addEventListener("submit", handleSubmit);
    }
    // Stripe Init
  }
  confirmOrderViaStripeForm(elements) {
    this.isLoading = true
    if (this.isLoading) {
      (document.querySelector("#submit") as HTMLButtonElement).disabled = true;
      window.document.querySelector("#spinner").classList.remove("hidden");
      window.document.querySelector("#button-text").classList.add("hidden");
    } else {
      (document.querySelector("#submit") as HTMLButtonElement).disabled = false;
      window.document.querySelector("#spinner").classList.add("hidden");
      window.document.querySelector("#button-text").classList.remove("hidden");
    }
    var userData3d;
    if (this.selectedShipment.shipment_id && this.selectedShipment.shipment_id.includes('-')) {
      userData3d = {
        payment_with_paypal: 0,
        paypal: "",
        promo_code: "",
        payment_with_stripe3ds: 1,
        payment_method_type: ["card", "klarna"],
        company_id: this.selectedShipment.company_id,
        service_type: this.selectedShipment.service_type,
        vendor: this.selectedShipment.vendor,
        b2b_shipment_number: this.b2b_shipment.shipment_number,
        b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
        shopper_email: this.form.value.emailAddress,
        b2b_user_email: this.memberDetails.email,
        from_address_id: this.customSenderInfo['id'],
        to_address: {
          name: this.form.value.recipient,
          street1: this.form.value.addressLineOne,
          street2: this.form.value.addressLineTwo,
          city: this.form.value.cityName,
          state: this.form.value.state,
          zip: this.form.value.postCode,
          country: this.form.value.country,
          phone: this.form.value.phoneNumber,
          email: this.form.value.emailAddress,
          company: this.form.value.companyName,
        },
        from_address: {
          name: this.customSenderInfo.senderName,
          street1: this.customSenderInfo.addressLineOne,
          street2: this.customSenderInfo.addressLineTwo,
          city: this.customSenderInfo.cityName,
          state: this.customSenderInfo.state,
          zip: this.customSenderInfo.postCode,
          country: this.customSenderInfo.country,
          phone: this.customSenderInfo.senderPhone,
          email: this.customSenderInfo.senderEmail
        },
        parcel: {
          length: this.parcelAndLabelOptionsForm.value.length,
          width: this.parcelAndLabelOptionsForm.value.width,
          height: this.parcelAndLabelOptionsForm.value.height,
          weight: this.parcelAndLabelOptionsForm.value.weight,
          weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
          dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
        },
        customs_info: {
          customs_items: this.customsForm.value.customsItems
        },
        options: {
          eel_pfc: this.customsForm.value.eelOrPfcNumber,
          restriction_type: this.customsForm.value.restrictionType,
          contents_type: this.customsForm.value.contentType,
          contents_explanation: this.customsForm.value.explanationOfContent,
          label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
          invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
        },
        insurance: parseInt(this.insuranceSelected),
        insurance_exists: parseInt(this.insuranceSelected),
      }
    } else {
      userData3d = {
        payment_with_paypal: 0,
        paypal: "",
        promo_code: "",
        payment_with_stripe3ds: 1,
        payment_method_type: ["card", "klarna"],
        company_id: this.selectedShipment.company_id,
        service_type: this.selectedShipment.service_type,
        vendor: this.selectedShipment.vendor,
        b2b_shipment_number: this.b2b_shipment.shipment_number,
        b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
        shopper_email: this.form.value.emailAddress,
        b2b_user_email: this.memberDetails.email,
        from_address_id: this.customSenderInfo['id'],
        to_address: {
          name: this.form.value.recipient,
          street1: this.form.value.addressLineOne,
          street2: this.form.value.addressLineTwo,
          city: this.form.value.cityName,
          state: this.form.value.state,
          zip: this.form.value.postCode,
          country: this.form.value.country,
          phone: this.form.value.phoneNumber,
          email: this.form.value.emailAddress,
          company: this.form.value.companyName,
        },
        from_address: {
          name: this.customSenderInfo.senderName,
          street1: this.customSenderInfo.addressLineOne,
          street2: this.customSenderInfo.addressLineTwo,
          city: this.customSenderInfo.cityName,
          state: this.customSenderInfo.state,
          zip: this.customSenderInfo.postCode,
          country: this.customSenderInfo.country,
          phone: this.customSenderInfo.senderPhone,
          email: this.customSenderInfo.senderEmail
        },
        parcel: {
          length: this.parcelAndLabelOptionsForm.value.length,
          width: this.parcelAndLabelOptionsForm.value.width,
          height: this.parcelAndLabelOptionsForm.value.height,
          weight: this.parcelAndLabelOptionsForm.value.weight,
          weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
          dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
        },
        customs_info: {
          customs_items: this.customsForm.value.customsItems
        },
        options: {
          eel_pfc: this.customsForm.value.eelOrPfcNumber,
          restriction_type: this.customsForm.value.restrictionType,
          contents_type: this.customsForm.value.contentType,
          contents_explanation: this.customsForm.value.explanationOfContent,
          label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
          invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
        },
        insurance: parseInt(this.insuranceSelected),
        insurance_exists: parseInt(this.insuranceSelected),
      }
    }
    this.signUpService.confirmB2BOrder(this.token, userData3d).pipe(
      switchMap((data) => {
        if (data["result"]["status"] == 200) {

          const baseUrl = `${this.stripeHostName}${this.lang}/b2b/create-shipment`;
          const params = {
            payment_with_paypal: '0',
            paypal: '',
            promo_code: '',
            payment_with_stripe3ds: '1',
            payment_method_type: JSON.stringify(["card", "klarna"]),
            company_id: this.selectedShipment.company_id,
            service_type: this.selectedShipment.service_type,
            vendor: this.selectedShipment.vendor,
            b2b_shipment_number: this.b2b_shipment.shipment_number,
            b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
            shopper_email: this.form.value.emailAddress,
            b2b_user_email: this.memberDetails.email,
            from_address_id: this.customSenderInfo['id'],
            to_address: JSON.stringify({
              name: this.form.value.recipient,
              street1: this.form.value.addressLineOne,
              street2: this.form.value.addressLineTwo,
              city: this.form.value.cityName,
              state: this.form.value.state,
              zip: this.form.value.postCode,
              country: this.form.value.country,
              phone: this.form.value.phoneNumber,
              email: this.form.value.emailAddress,
              company: this.form.value.companyName,
            }),
            from_address: JSON.stringify({
              name: this.customSenderInfo.senderName,
              street1: this.customSenderInfo.addressLineOne,
              street2: this.customSenderInfo.addressLineTwo,
              city: this.customSenderInfo.cityName,
              state: this.customSenderInfo.state,
              zip: this.customSenderInfo.postCode,
              country: this.customSenderInfo.country,
              phone: this.customSenderInfo.senderPhone,
              email: this.customSenderInfo.senderEmail
            }),
            parcel: JSON.stringify({
              length: this.parcelAndLabelOptionsForm.value.length,
              width: this.parcelAndLabelOptionsForm.value.width,
              height: this.parcelAndLabelOptionsForm.value.height,
              weight: this.parcelAndLabelOptionsForm.value.weight,
              weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
              dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
            }),
            customs_info: JSON.stringify({
              customs_items: this.customsForm.value.customsItems
            }),
            options: JSON.stringify({
              eel_pfc: this.customsForm.value.eelOrPfcNumber,
              restriction_type: this.customsForm.value.restrictionType,
              contents_type: this.customsForm.value.contentType,
              contents_explanation: this.customsForm.value.explanationOfContent,
              label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
              invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
            }),
            insurance: this.insuranceSelected.toString(),
            insurance_exists: this.insuranceSelected.toString(),
          };
          const stringParams: Record<string, string> = {};
          for (const key in params) {
            stringParams[key] = String(params[key]);
          }
          const queryString = new URLSearchParams(stringParams).toString();
          const returnUrl = `${baseUrl}?${queryString}`;



          const stripe = Stripe(this.stripeClientSecret);
          return stripe.confirmPayment(
            {
              elements,
              confirmParams: {
                // api/ Anon id, cart id 
                return_url: returnUrl,
              },
              redirect: "if_required"
            }
          ).then(function (result) {
            if (result.error) {
              return result;
            } else {
              if (result.paymentIntent.status === 'succeeded') {
                return data;
              }
            }
          });
        } else {
          this.toastr.error(data["result"]["message"], 'Error');
          this.isLoading = false;
          if (this.isLoading) {
            // Disable the button and show a spinner
            (document.querySelector("#submit") as HTMLButtonElement).disabled = true;
            window.document.querySelector("#spinner").classList.remove("hidden");
            window.document.querySelector("#button-text").classList.add("hidden");
          } else {
            (document.querySelector("#submit") as HTMLButtonElement).disabled = false;
            window.document.querySelector("#spinner").classList.add("hidden");
            window.document.querySelector("#button-text").classList.remove("hidden");
          }
        }
      }),
      catchError((err) => {
        return err;
      })
    ).subscribe(async data => {
      if (data['error']) {
        let errorMessage = data['error']['payment_intent']['last_payment_error']['message']
        if (errorMessage == "The latest payment attempt of this PaymentIntent has failed or been canceled, and the attached payment method has been removed. You can try confirming again with a new payment method.") {
          errorMessage = "Payment has failed or been canceled. You can try confirming again with a new payment method."
        } else if (errorMessage == "The provided PaymentMethod has failed authentication. You can provide payment_method_data or a new PaymentMethod to attempt to fulfill this PaymentIntent again.") {
          errorMessage = "Payment has failed authentication. You can try confirming again with a new payment method."
        }
        // Hata olsa bile sipariş isteği
        if (this.selectedShipment.shipment_id && this.selectedShipment.shipment_id.includes('-')) {
          confirmOrderData = {
            payment_with_paypal: 0,
            paypal: "",
            promo_code: "",
            payment_with_stripe3ds: 1,
            payment_method_type: ["card", "klarna"],
            company_id: this.selectedShipment.company_id,
            service_type: this.selectedShipment.service_type,
            vendor: this.selectedShipment.vendor,
            b2b_shipment_number: this.b2b_shipment.shipment_number,
            b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
            shopper_email: this.form.value.emailAddress,
            b2b_user_email: this.memberDetails.email,
            from_address_id: this.customSenderInfo['id'],
            to_address: {
              name: this.form.value.recipient,
              street1: this.form.value.addressLineOne,
              street2: this.form.value.addressLineTwo,
              city: this.form.value.cityName,
              state: this.form.value.state,
              zip: this.form.value.postCode,
              country: this.form.value.country,
              phone: this.form.value.phoneNumber,
              email: this.form.value.emailAddress,
              company: this.form.value.companyName,
            },
            from_address: {
              name: this.customSenderInfo.senderName,
              street1: this.customSenderInfo.addressLineOne,
              street2: this.customSenderInfo.addressLineTwo,
              city: this.customSenderInfo.cityName,
              state: this.customSenderInfo.state,
              zip: this.customSenderInfo.postCode,
              country: this.customSenderInfo.country,
              phone: this.customSenderInfo.senderPhone,
              email: this.customSenderInfo.senderEmail
            },
            parcel: {
              length: this.parcelAndLabelOptionsForm.value.length,
              width: this.parcelAndLabelOptionsForm.value.width,
              height: this.parcelAndLabelOptionsForm.value.height,
              weight: this.parcelAndLabelOptionsForm.value.weight,
              weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
              dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
            },
            customs_info: {
              customs_items: this.customsForm.value.customsItems
            },
            options: {
              eel_pfc: this.customsForm.value.eelOrPfcNumber,
              restriction_type: this.customsForm.value.restrictionType,
              contents_type: this.customsForm.value.contentType,
              contents_explanation: this.customsForm.value.explanationOfContent,
              label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
              invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
            },
            insurance: parseInt(this.insuranceSelected),
            insurance_exists: parseInt(this.insuranceSelected),
          }
        } else {
          confirmOrderData = {
            payment_with_paypal: 0,
            paypal: "",
            promo_code: "",
            payment_with_stripe3ds: 1,
            payment_method_type: ["card", "klarna"],
            company_id: this.selectedShipment.company_id,
            service_type: this.selectedShipment.service_type,
            vendor: this.selectedShipment.vendor,
            b2b_shipment_number: this.b2b_shipment.shipment_number,
            b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
            shopper_email: this.form.value.emailAddress,
            b2b_user_email: this.memberDetails.email,
            from_address_id: this.customSenderInfo['id'],
            to_address: {
              name: this.form.value.recipient,
              street1: this.form.value.addressLineOne,
              street2: this.form.value.addressLineTwo,
              city: this.form.value.cityName,
              state: this.form.value.state,
              zip: this.form.value.postCode,
              country: this.form.value.country,
              phone: this.form.value.phoneNumber,
              email: this.form.value.emailAddress,
              company: this.form.value.companyName,
            },
            from_address: {
              name: this.customSenderInfo.senderName,
              street1: this.customSenderInfo.addressLineOne,
              street2: this.customSenderInfo.addressLineTwo,
              city: this.customSenderInfo.cityName,
              state: this.customSenderInfo.state,
              zip: this.customSenderInfo.postCode,
              country: this.customSenderInfo.country,
              phone: this.customSenderInfo.senderPhone,
              email: this.customSenderInfo.senderEmail
            },
            parcel: {
              length: this.parcelAndLabelOptionsForm.value.length,
              width: this.parcelAndLabelOptionsForm.value.width,
              height: this.parcelAndLabelOptionsForm.value.height,
              weight: this.parcelAndLabelOptionsForm.value.weight,
              weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
              dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
            },
            customs_info: {
              customs_items: this.customsForm.value.customsItems
            },
            options: {
              eel_pfc: this.customsForm.value.eelOrPfcNumber,
              restriction_type: this.customsForm.value.restrictionType,
              contents_type: this.customsForm.value.contentType,
              contents_explanation: this.customsForm.value.explanationOfContent,
              label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
              invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
            },
            insurance: parseInt(this.insuranceSelected),
            insurance_exists: parseInt(this.insuranceSelected),
          }
        }
        this.signUpService.confirmB2BOrder(this.token, confirmOrderData).subscribe(data => {
          if (data['result']['status'] == 200) {
            this.toastr.success(data["result"]["message"], 'Success');
            this.signUpService.getB2BShipmentDetailViaID(this.token, this.b2b_shipment.id).subscribe({
              next: (getShipmentRes) => {
                this.paymentDone = true;
                this.paymentCompletedShipment = getShipmentRes['data'];
                this.currentStep = 4;
                this.sendGTMSuccessEvent(getShipmentRes['data']);
                this.checkUserMoveCap();
                this.shipment_awb_no = getShipmentRes['data']['awb_no'];
                window.scrollTo(0, 0);
              }
            })
          } else {
            this.isLoading = false;
            if (this.isLoading) {
              // Disable the button and show a spinner
              (document.querySelector("#submit") as HTMLButtonElement).disabled = true;
              window.document.querySelector("#spinner").classList.remove("hidden");
              window.document.querySelector("#button-text").classList.add("hidden");
            } else {
              (document.querySelector("#submit") as HTMLButtonElement).disabled = false;
              window.document.querySelector("#spinner").classList.add("hidden");
              window.document.querySelector("#button-text").classList.remove("hidden");
            }
            this.toastr.error(errorMessage, 'Error');
            if (data["result"]["status"] == 930 || data["result"]["status"] == 931) {
              this.openErrorDialog();
            }
          }
        })
        // Hata olsa bile sipariş isteği 
      } else {
        var confirmOrderData;
        if (this.selectedShipment.shipment_id && this.selectedShipment.shipment_id.includes('-')) {
          confirmOrderData = {
            payment_with_paypal: 0,
            paypal: "",
            promo_code: "",
            payment_with_stripe3ds: 1,
            payment_method_type: ["card", "klarna"],
            company_id: this.selectedShipment.company_id,
            service_type: this.selectedShipment.service_type,
            vendor: this.selectedShipment.vendor,
            b2b_shipment_number: this.b2b_shipment.shipment_number,
            b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
            shopper_email: this.form.value.emailAddress,
            b2b_user_email: this.memberDetails.email,
            from_address_id: this.customSenderInfo['id'],
            to_address: {
              name: this.form.value.recipient,
              street1: this.form.value.addressLineOne,
              street2: this.form.value.addressLineTwo,
              city: this.form.value.cityName,
              state: this.form.value.state,
              zip: this.form.value.postCode,
              country: this.form.value.country,
              phone: this.form.value.phoneNumber,
              email: this.form.value.emailAddress,
              company: this.form.value.companyName,
            },
            from_address: {
              name: this.customSenderInfo.senderName,
              street1: this.customSenderInfo.addressLineOne,
              street2: this.customSenderInfo.addressLineTwo,
              city: this.customSenderInfo.cityName,
              state: this.customSenderInfo.state,
              zip: this.customSenderInfo.postCode,
              country: this.customSenderInfo.country,
              phone: this.customSenderInfo.senderPhone,
              email: this.customSenderInfo.senderEmail
            },
            parcel: {
              length: this.parcelAndLabelOptionsForm.value.length,
              width: this.parcelAndLabelOptionsForm.value.width,
              height: this.parcelAndLabelOptionsForm.value.height,
              weight: this.parcelAndLabelOptionsForm.value.weight,
              weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
              dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
            },
            customs_info: {
              customs_items: this.customsForm.value.customsItems
            },
            options: {
              eel_pfc: this.customsForm.value.eelOrPfcNumber,
              restriction_type: this.customsForm.value.restrictionType,
              contents_type: this.customsForm.value.contentType,
              contents_explanation: this.customsForm.value.explanationOfContent,
              label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
              invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
            },
            insurance: parseInt(this.insuranceSelected),
            insurance_exists: parseInt(this.insuranceSelected),
          }
        } else {
          confirmOrderData = {
            payment_with_paypal: 0,
            paypal: "",
            promo_code: "",
            payment_with_stripe3ds: 1,
            payment_method_type: ["card", "klarna"],
            company_id: this.selectedShipment.company_id,
            service_type: this.selectedShipment.service_type,
            vendor: this.selectedShipment.vendor,
            b2b_shipment_number: this.b2b_shipment.shipment_number,
            b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
            shopper_email: this.form.value.emailAddress,
            b2b_user_email: this.memberDetails.email,
            from_address_id: this.customSenderInfo['id'],
            to_address: {
              name: this.form.value.recipient,
              street1: this.form.value.addressLineOne,
              street2: this.form.value.addressLineTwo,
              city: this.form.value.cityName,
              state: this.form.value.state,
              zip: this.form.value.postCode,
              country: this.form.value.country,
              phone: this.form.value.phoneNumber,
              email: this.form.value.emailAddress,
              company: this.form.value.companyName,
            },
            from_address: {
              name: this.customSenderInfo.senderName,
              street1: this.customSenderInfo.addressLineOne,
              street2: this.customSenderInfo.addressLineTwo,
              city: this.customSenderInfo.cityName,
              state: this.customSenderInfo.state,
              zip: this.customSenderInfo.postCode,
              country: this.customSenderInfo.country,
              phone: this.customSenderInfo.senderPhone,
              email: this.customSenderInfo.senderEmail
            },
            parcel: {
              length: this.parcelAndLabelOptionsForm.value.length,
              width: this.parcelAndLabelOptionsForm.value.width,
              height: this.parcelAndLabelOptionsForm.value.height,
              weight: this.parcelAndLabelOptionsForm.value.weight,
              weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
              dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
            },
            customs_info: {
              customs_items: this.customsForm.value.customsItems
            },
            options: {
              eel_pfc: this.customsForm.value.eelOrPfcNumber,
              restriction_type: this.customsForm.value.restrictionType,
              contents_type: this.customsForm.value.contentType,
              contents_explanation: this.customsForm.value.explanationOfContent,
              label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
              invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
            },
            insurance: parseInt(this.insuranceSelected),
            insurance_exists: parseInt(this.insuranceSelected),
          }
        }
        this.signUpService.confirmB2BOrder(this.token, confirmOrderData).subscribe(data => {
          if (data['result']['status'] == 200) {
            this.toastr.success(data["result"]["message"], 'Success');
            this.signUpService.getB2BShipmentDetailViaID(this.token, this.b2b_shipment.id).subscribe({
              next: (getShipmentRes) => {
                this.paymentDone = true;
                this.paymentCompletedShipment = getShipmentRes['data'];
                this.currentStep = 4;
                this.sendGTMSuccessEvent(getShipmentRes['data']);
                this.checkUserMoveCap();
                this.shipment_awb_no = getShipmentRes['data']['awb_no'];
                window.scrollTo(0, 0);
              }
            })
          }
          else {
            this.isLoading = false;
            this.toastr.error(data["result"]["message"], 'Error');
            if (this.isLoading) {
              // Disable the button and show a spinner
              (document.querySelector("#submit") as HTMLButtonElement).disabled = true;
              window.document.querySelector("#spinner").classList.remove("hidden");
              window.document.querySelector("#button-text").classList.add("hidden");
            } else {
              (document.querySelector("#submit") as HTMLButtonElement).disabled = false;
              window.document.querySelector("#spinner").classList.add("hidden");
              window.document.querySelector("#button-text").classList.remove("hidden");
            }
            if (data["result"]["status"] == 930 || data["result"]["status"] == 931) {
              this.openErrorDialog();

            }
          }
        })
      }
    })
  }

  stripePaymentConfirm(paymentIntent) {
    var confirmOrderData;
    if (this.selectedShipment.shipment_id && this.selectedShipment.shipment_id.includes('-')) {
      confirmOrderData = {
        payment_with_paypal: 0,
        paypal: "",
        promo_code: "",
        payment_with_stripe3ds: 1,
        payment_method_type: ["card", "klarna"],
        company_id: this.selectedShipment.company_id,
        service_type: this.selectedShipment.service_type,
        vendor: this.selectedShipment.vendor,
        b2b_shipment_number: this.b2b_shipment.shipment_number,
        b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
        shopper_email: this.form.value.emailAddress,
        b2b_user_email: this.memberDetails.email,
        from_address_id: this.customSenderInfo['id'],
        to_address: {
          name: this.form.value.recipient,
          street1: this.form.value.addressLineOne,
          street2: this.form.value.addressLineTwo,
          city: this.form.value.cityName,
          state: this.form.value.state,
          zip: this.form.value.postCode,
          country: this.form.value.country,
          phone: this.form.value.phoneNumber,
          email: this.form.value.emailAddress,
          company: this.form.value.companyName,
        },
        from_address: {
          name: this.customSenderInfo.senderName,
          street1: this.customSenderInfo.addressLineOne,
          street2: this.customSenderInfo.addressLineTwo,
          city: this.customSenderInfo.cityName,
          state: this.customSenderInfo.state,
          zip: this.customSenderInfo.postCode,
          country: this.customSenderInfo.country,
          phone: this.customSenderInfo.senderPhone,
          email: this.customSenderInfo.senderEmail
        },
        parcel: {
          length: parseFloat(this.parcelAndLabelOptionsForm.value.length),
          width: this.parcelAndLabelOptionsForm.value.width,
          height: this.parcelAndLabelOptionsForm.value.height,
          weight: this.parcelAndLabelOptionsForm.value.weight,
          weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
          dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
        },
        customs_info: {
          customs_items: this.customsForm.value.customsItems
        },
        options: {
          eel_pfc: this.customsForm.value.eelOrPfcNumber ? this.customsForm.value.eelOrPfcNumber : "NOEEI 30.37(a)",
          restriction_type: this.customsForm.value.restrictionType ? this.customsForm.value.restrictionType : "None",
          contents_type: this.customsForm.value.contentType ? this.customsForm.value.contentType : "Merchandise",
          contents_explanation: this.customsForm.value.explanationOfContent ? this.customsForm.value.explanationOfContent : "",
          label_format: this.parcelAndLabelOptionsForm.value.labelFormat ? this.parcelAndLabelOptionsForm.value.labelFormat : "PDF",
          invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber ? this.parcelAndLabelOptionsForm.value.invoiceNumber : ""
        },
        insurance: parseInt(this.insuranceSelected),
        insurance_exists: parseInt(this.insuranceSelected),
        payment_intent: paymentIntent,
      }
    } else {
      confirmOrderData = {
        payment_with_paypal: 0,
        paypal: "",
        promo_code: "",
        payment_with_stripe3ds: 1,
        payment_intent: paymentIntent,
        payment_method_type: ["card", "klarna"],
        company_id: this.selectedShipment.company_id,
        service_type: this.selectedShipment.service_type,
        vendor: this.selectedShipment.vendor,
        b2b_shipment_number: this.b2b_shipment.shipment_number,
        b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
        shopper_email: this.form.value.emailAddress,
        b2b_user_email: this.memberDetails.email,
        from_address_id: this.customSenderInfo['id'],
        to_address: {
          name: this.form.value.recipient,
          street1: this.form.value.addressLineOne,
          street2: this.form.value.addressLineTwo,
          city: this.form.value.cityName,
          state: this.form.value.state,
          zip: this.form.value.postCode,
          country: this.form.value.country,
          phone: this.form.value.phoneNumber,
          email: this.form.value.emailAddress,
          company: this.form.value.companyName,
        },
        from_address: {
          name: this.customSenderInfo.senderName,
          street1: this.customSenderInfo.addressLineOne,
          street2: this.customSenderInfo.addressLineTwo,
          city: this.customSenderInfo.cityName,
          state: this.customSenderInfo.state,
          zip: this.customSenderInfo.postCode,
          country: this.customSenderInfo.country,
          phone: this.customSenderInfo.senderPhone,
          email: this.customSenderInfo.senderEmail
        },
        parcel: {
          length: parseFloat(this.parcelAndLabelOptionsForm.value.length),
          width: parseFloat(this.parcelAndLabelOptionsForm.value.width),
          height: parseFloat(this.parcelAndLabelOptionsForm.value.height),
          weight: parseFloat(this.parcelAndLabelOptionsForm.value.weight),
          weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
          dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
        },
        customs_info: {
          customs_items: this.customsForm.value.customsItems
        },
        options: {
          eel_pfc: this.customsForm.value.eelOrPfcNumber ? this.customsForm.value.eelOrPfcNumber : "NOEEI 30.37(a)",
          restriction_type: this.customsForm.value.restrictionType ? this.customsForm.value.restrictionType : "None",
          contents_type: this.customsForm.value.contentType ? this.customsForm.value.contentType : "Merchandise",
          contents_explanation: this.customsForm.value.explanationOfContent ? this.customsForm.value.explanationOfContent : "",
          label_format: this.parcelAndLabelOptionsForm.value.labelFormat ? this.parcelAndLabelOptionsForm.value.labelFormat : "PDF",
          invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber ? this.parcelAndLabelOptionsForm.value.invoiceNumber : ""
        },
        insurance: parseInt(this.insuranceSelected),
        insurance_exists: parseInt(this.insuranceSelected),
      }
    }
    this.signUpService.confirmB2BOrder(this.token, confirmOrderData).subscribe(data => {
      if (data['result']['status'] == 200) {
        this.signUpService.getB2BShipmentDetailViaID(this.token, this.b2b_shipment.id).subscribe({
          next: (getShipmentRes) => {
            this.paymentDone = true;
            this.paymentCompletedShipment = getShipmentRes['data'];
            this.currentStep = 4;
            this.sendGTMSuccessEvent(getShipmentRes['data']);
            this.stepper.linear = false;
            while (this.stepper.selectedIndex < this.currentStep) {
              this.stepper.selectedIndex = Number(this.stepper.selectedIndex) + 1;
            }
            this.stepper.selectedIndex = this.currentStep;
            setTimeout(() => {
              this.stepper.linear = true;
            });
            this.checkUserMoveCap();
            this.shipment_awb_no = getShipmentRes['data']['awb_no'];
            window.scrollTo(0, 0);
          }
        })
        this.toastr.success(data["result"]["message"], 'Success');
      }
      else {
        this.isLoading = false;
        this.toastr.error(data["result"]["message"], 'Error');
        if (data["result"]["status"] == 930 || data["result"]["status"] == 931) {
          this.openErrorDialog();
        }
        if (this.isLoading) {
          // Disable the button and show a spinner
          (document.querySelector("#submit") as HTMLButtonElement).disabled = true;
          window.document.querySelector("#spinner").classList.remove("hidden");
          window.document.querySelector("#button-text").classList.add("hidden");
        } else {
          (document.querySelector("#submit") as HTMLButtonElement).disabled = false;
          window.document.querySelector("#spinner").classList.add("hidden");
          window.document.querySelector("#button-text").classList.remove("hidden");
        }
      }
    })
  }
  paymentCompletedShipment: completedShipment | any = {

  }
  selectedB2BAddress;
  selectB2BAddress(addressIndex) {
    this.selectedB2BAddress = this.memberDetails.addresses[addressIndex];
  }
  newSelectedCard(creditCard) {
    this.selectedCreditCard = creditCard;
    this.selectedCreditCardID = creditCard.id;
  }
  printLabel(label) {
    window.open(label, '_blank');
  }
  drawGooglePayButton() {
    let api = this.signUpService.api;
    let stripeElementToken = this.token;
    let googlePayClientSecret;
    let googlePayOrderAmount;
    let googlePayOrderDesc;
    let googlePayB2b = {
      stripe_payment_intents: {
        pi_gpay: ''
      }
    };
    let InitForGooglePay = async () => {

      var userDataGooglePay = {
        company_id: this.selectedShipment.company_id,
        payment_with_paypal: 0,
        paypal: "",
        promo_code: "",
        service_type: this.selectedShipment.service_type,
        vendor: this.selectedShipment.vendor,
        payment_with_stripe3ds: 1,
        payment_method_type: ["card", "klarna"],
        google_pay: 1,
        customer: this.selectedCreditCard?.customer,
        b2b_shipment_number: this.b2b_shipment.shipment_number,
        b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
        shopper_email: this.form.value.emailAddress,
        b2b_user_email: this.memberDetails.email,
        from_address_id: this.customSenderInfo['id'],
        to_address: {
          name: this.form.value.recipient,
          street1: this.form.value.addressLineOne,
          street2: this.form.value.addressLineTwo,
          city: this.form.value.cityName,
          state: this.form.value.state,
          zip: this.form.value.postCode,
          country: this.form.value.country,
          phone: this.form.value.phoneNumber,
          email: this.form.value.emailAddress,
          company: this.form.value.companyName,
        },
        from_address: {
          name: this.customSenderInfo.senderName,
          street1: this.customSenderInfo.addressLineOne,
          street2: this.customSenderInfo.addressLineTwo,
          city: this.customSenderInfo.cityName,
          state: this.customSenderInfo.state,
          zip: this.customSenderInfo.postCode,
          country: this.customSenderInfo.country,
          phone: this.customSenderInfo.senderPhone,
          email: this.customSenderInfo.senderEmail
        },
        parcel: {
          length: this.parcelAndLabelOptionsForm.value.length,
          width: this.parcelAndLabelOptionsForm.value.width,
          height: this.parcelAndLabelOptionsForm.value.height,
          weight: this.parcelAndLabelOptionsForm.value.weight,
          weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
          dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
        },
        customs_info: {
          customs_items: this.customsForm.value.customsItems
        },
        options: {
          eel_pfc: this.customsForm.value.eelOrPfcNumber,
          restriction_type: this.customsForm.value.restrictionType,
          contents_type: this.customsForm.value.contentType,
          contents_explanation: this.customsForm.value.explanationOfContent,
          label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
          invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
        },
        insurance: parseInt(this.insuranceSelected),
        insurance_exists: parseInt(this.insuranceSelected),
      }
      const response = await fetch(`${api}shipment/b2b/pay`, {
        method: "POST",
        headers: {
          "x-access-token": stripeElementToken,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          company_id: this.selectedShipment.company_id,
          payment_with_paypal: 0,
          paypal: "",
          promo_code: "",
          service_type: this.selectedShipment.service_type,
          vendor: this.selectedShipment.vendor,
          payment_with_stripe3ds: 1,
          payment_method_type: ["card", "klarna"],
          google_pay: 1,
          customer: this.selectedCreditCard?.customer,
          b2b_shipment_number: this.b2b_shipment.shipment_number,
          b2b_recipient_id: this.b2b_shipment.b2b_recipient_id,
          shopper_email: this.form.value.emailAddress,
          b2b_user_email: this.memberDetails.email,
          from_address_id: this.customSenderInfo['id'],
          to_address: {
            name: this.form.value.recipient,
            street1: this.form.value.addressLineOne,
            street2: this.form.value.addressLineTwo,
            city: this.form.value.cityName,
            state: this.form.value.state,
            zip: this.form.value.postCode,
            country: this.form.value.country,
            phone: this.form.value.phoneNumber,
            email: this.form.value.emailAddress,
            company: this.form.value.companyName,
          },
          from_address: {
            name: this.customSenderInfo.senderName,
            street1: this.customSenderInfo.addressLineOne,
            street2: this.customSenderInfo.addressLineTwo,
            city: this.customSenderInfo.cityName,
            state: this.customSenderInfo.state,
            zip: this.customSenderInfo.postCode,
            country: this.customSenderInfo.country,
            phone: this.customSenderInfo.senderPhone,
            email: this.customSenderInfo.senderEmail
          },
          parcel: {
            length: this.parcelAndLabelOptionsForm.value.length,
            width: this.parcelAndLabelOptionsForm.value.width,
            height: this.parcelAndLabelOptionsForm.value.height,
            weight: this.parcelAndLabelOptionsForm.value.weight,
            weight_unit: this.parcelAndLabelOptionsForm.value.weightUnit == 'Pound' ? 'lbs' : 'kg',
            dimension_unit: this.parcelAndLabelOptionsForm.value.dimensionUnit == 'Centimeter' ? 'cm' : 'inch',
          },
          customs_info: {
            customs_items: this.customsForm.value.customsItems
          },
          options: {
            eel_pfc: this.customsForm.value.eelOrPfcNumber,
            restriction_type: this.customsForm.value.restrictionType,
            contents_type: this.customsForm.value.contentType,
            contents_explanation: this.customsForm.value.explanationOfContent,
            label_format: this.parcelAndLabelOptionsForm.value.labelFormat,
            invoice_number: this.parcelAndLabelOptionsForm.value.invoiceNumber
          },
          insurance: parseInt(this.insuranceSelected),
          insurance_exists: parseInt(this.insuranceSelected),
        }),
      }).then(response => response.json()).then(data => {
        googlePayClientSecret = data['data']['client_secret'];
        googlePayOrderAmount = data['data']['amount'];
        googlePayOrderDesc = data['data']['description'];
        googlePayB2b.stripe_payment_intents.pi_gpay = data['data']['id'];
        return data;
      });
    }
    InitForGooglePay();
  }
  insuranceAmount: number = 0;
  showInsuranceDetails;
  disableInsuranceRadios;
  insuranceSelected = "0";
  changeInsurance() {
    this.disableInsuranceRadios = true;

    if (this.userID && this.token) {
      this.updatePaymentIntent();
    }

  }

  openArrangePickupDialog() {
    const senderAddresses = this.memberDetails.addresses;
    const dialogRef = this.dialog.open(B2BArrangePickupDialog, {
      data: { shipment: this.paymentCompletedShipment, addresses: senderAddresses },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.paymentCompletedShipment = result;
      }
    });
  }

  openArrangePickupDetailDialog(shipment) {
    const senderAddresses = this.memberDetails.addresses;
    this.dialog.open(B2BArrangePickupDetailsDialog, {
      data: { shipment: shipment, addresses: senderAddresses },
    });


  }

  returnCountryName(countryCode) {
    return this.allCountries.find(country => country.code == countryCode).name;
  }
  copyToClipboard(text: string, thing = ''): void {
    this.clipboard.copy(text);
    this.toastr.success(`${thing} copied to clipboard`, 'Success');
  }
}
export interface completedShipment {
  shipment_number?: string,
  b2b_user_full_name?: string,
  b2b_recipient_id?: string,
  b2b_user_id?: string,
  b2b_user_address?: {},
  recipient_full_name?: string,
  recipient_address?: {},
  content?: any[],
  charge?: {
    additional_handling_surcharge?: {
      amount?: number | null,
      currency?: string
    },
    brexit_fee?: {
      amount?: number | null,
      currency?: string
    },
    elevated_risk_fee?: {
      amount?: number | null,
      currency?: string
    },
    emergency_situation_surcharge?: {
      amount?: number | null,
      currency?: string
    },
    extended_area_fee?: {
      amount?: number | null,
      currency?: string
    },
    export_declaration_fee?: {
      amount?: number | null,
      currency?: string
    },
    insurance?: {
      amount?: number | null,
      currency?: string
    },
    non_standart_pickup_fee?: {
      amount?: number | null,
      currency?: string
    },
    peak_surcharge?: {
      amount?: number | null,
      currency?: string
    },
    residential_delivery_charge?: {
      amount?: number | null,
      currency?: string
    },
    restricted_destination_fee?: {
      amount?: number | null,
      currency?: string
    },
    shipment: {
      amount?: number | null,
      currency?: string
    }
    paid?: {
      amount?: number | null,
      currency?: string
    }
  },
  shipment_cost?: {
    shipment_cost?: number | null,
    insurance?: number | null,
    additional_handling_surcharge: number | null,
    brexit_fee: number | null,
    elevated_risk_fee: number | null,
    emergency_situation_surcharge: number | null,
    export_declaration_fee: number | null,
    extended_area_fee: number | null,
    fuel_surcharge: number | null,
    non_standart_pickup_fee: number | null,
    peak_surcharge: number | null,
    residential_delivery_charge: number | null,
    restricted_area_fee: number | null
    consolidation: number | null,
    cost: number | null,
    oversized_package_fee: number | null

  }

}
export interface b2bShipment {
}
export interface b2bShipmentData {
  shipment_number?: string,
  b2b_recipient_id?: string,
  b2b_user_id?: string,
  shipment?: {},
  id?: string,
  contains_battery?: number,
  stripe_payment_intents?: {}
}
export interface b2bShipmentAmount {
  shipment_amount: number,
  emergency_situation_surcharge: number,
  peak_surcharge: number,
  fuel_surcharge_rate: number,
  vendor: string,
  company_id: number,
  service_type: number,
  service_type_name: string,
  restricted_destination_fee: number,
  elevated_risk_fee: number,
  non_standard_pickup_fee: number,
  total_shipment_amount: number,
  estimated_delivery: string,
  extended_area_amount: number,
  additional_handling_surcharge: number,
  oversize_package_fee: number,
  residential_delivery_charge: number,
  brexit_fee: number,
  export_declaration_fee: number,
  repacking_service_fee: number,
  amount?: number,
  company_name?: number
}
export interface DialogData {
  addItemFormValues: object
}
export interface CourierCompany {
  id: number,
  name: string
}
export interface b2bSenderInfo {
  senderName?: string,
  senderPhone?: string,
  senderEmail?: string,
  addressLineOne?: string,
  addressLineTwo?: string,
  country?: string,
  cityName?: string,
  state?: string,
  postCode?: string,
  id?: string
}